// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/Cairo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/Cairo-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/Cairo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/Cairo-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/Cairo-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3Csvg width=%2740%27 height=%2740%27 viewBox=%270 0 40 40%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M0 20 Q10 10 20 20 T40 20%27 stroke=%27%23fff%27 fill=%27none%27 stroke-width=%271%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Cairo-Regular";
  src: local("CairoRrgular"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}

@font-face {
  font-family: "Cairo-Medium";
  src: local("CairoMedium"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}

@font-face {
  font-family: "Cairo-Bold";
  src: local("CairoBold"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}

@font-face {
  font-family: "Cairo-ExtraBold";
  src: local("ExtraBold"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}

@font-face {
  font-family: "Cairo-SemiBold";
  src: local("SemiBold"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
}

:root {
  --primarymehroon: #B63436;
  --lightdark: #333333;
  --harddark: #1A1A1A;
  --white: #fff;
  --black: #000;
  --offwhite: #D9D9D9;
}


a,
p,
li,
span {
  font-family: system-ui;
  text-decoration: none;
  padding: 0px;
}

/* :where(.css-dev-only-do-not-override-zl9ks2)[class^="ant-layout"],
:where(.css-dev-only-do-not-override-zl9ks2)[class*=" ant-layout"] {
  font-size: 0;
} */
.ant-layout {
  background: transparent;
}

a,
p,
li,
span,
h1,
h2,
h3,
h4,
h5,
h6,
strong,
b {
  margin: 0;
  padding: 0;
}


.row {
  margin: 0;
}




.card-setsider .imgset img {
  border-radius: 4px;
  box-shadow: 0px 0px 14px -4px #bcb320;
  margin: 4px 0px;
}

.card-setsider:hover .imgset img {
  border-radius: 22px;
  transform: 37%;
  transform: scale(1.04);
  transition: 1s;
}

.card-setsider .imgset {
  border-radius: 10px;
}

.adminpanelhdr {
  background: #133a46 !important;
}

.ant-menu-dark,
.ant-menu-dark>.ant-menu {
  background: transparent;
}

.ant-layout .ant-layout-sider {
  background: #f0fbff;
}

.ant-menu-dark.ant-menu-inline .ant-menu-sub.ant-menu-inline,
.ant-menu-dark>.ant-menu.ant-menu-inline .ant-menu-sub.ant-menu-inline {
  background: #133a46;
}

.ant-menu-dark .ant-menu-item-selected,
.ant-menu-dark>.ant-menu .ant-menu-item-selected {
  background-color: #0f323d;
}

.ant-layout .ant-layout-sider-trigger {
  background: #133a46;
}

.ant-layout-header {
  height: auto !important;
}

.row-breadcrumb.row {
  background: #f8f8f8;
}

.card.graphscards {
  background: #011930;
}

.ant-layout .ant-layout-sider .ant-menu-dark .ant-menu-item a,
.ant-layout .ant-layout-sider .ant-menu-dark>.ant-menu .ant-menu-item a,
.ant-layout .ant-layout-sider .ant-menu-dark .ant-menu-item a:hover,
.ant-layout .ant-layout-sider .ant-menu-dark>.ant-menu .ant-menu-item a:hover {
  color: #858585;
}

.ant-layout .ant-layout-sider-trigger {
  background: #f0fbff;
}

.ant-layout .ant-layout-sider-trigger {
  background: #96d08c;
}

.ant-layout-sider-children .ant-menu-dark .ant-menu-item,
.ant-layout-sider-children .ant-menu-dark>.ant-menu .ant-menu-item,
.ant-layout-sider-children .ant-menu-dark .ant-menu-submenu-title,
.ant-layout-sider-children .ant-menu-dark>.ant-menu .ant-menu-submenu-title {
  color: #858585 !important;
}

.card.graphscards div {
  line-height: initial;
}

.card.graphscards {
  background: #011930;
  padding: 8px;
  border-radius: 4px;
  color: #b8b8b8;
}

.card.graphscards {
  background: #011930;
  padding: 8px;
  border-radius: 4px;
  color: #b8b8b8;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.ant-layout-header {
  height: auto;
  line-height: initial;
}

.ant-layout-sider .ant-menu-dark .ant-menu-item-selected,
.ant-layout-sider .ant-menu-dark>.ant-menu .ant-menu-item-selected {
  background-color: #34C759;
  color: #fff !important;
}

.ant-layout-sider .ant-menu-dark .ant-menu-item-selected a {
  color: #fff !important;
}

.ant-menu-dark.ant-menu-inline .ant-menu-sub.ant-menu-inline,
.ant-menu-dark>.ant-menu.ant-menu-inline .ant-menu-sub.ant-menu-inline {
  background: #e5f8ff;
}

.login-bg {
  min-height: 100vh;
  background: #f3f4f6;
  display: flex;
  align-items: center;
}

.login-card {
  min-height: 640px;
  background: #fff;
  border-radius: 28px;
  display: flex;
  overflow: hidden;
  box-shadow: 0 16px 60px rgba(0, 0, 0, 0.12);
}

.login-left {
  width: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 48px;
}

.login-form-wrap {
  width: 100%;
  max-width: 420px;
}

.login-title {
  font-size: 28px;
  font-weight: 700;
  color: #1a1a1a;
}

.login-subtitle {
  font-size: 14px;
  color: #8c8c8c;
}

.login-row-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 10px 0 18px;
}

.login-remember {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #666;
  -webkit-user-select: none;
          user-select: none;
}

.login-remember input {
  width: 14px;
  height: 14px;
  accent-color: #35b558;
}

.login-right {
  width: 50%;
  background: #eaf7ef;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 40px 24px;
}

.login-illustration-circle {
  width: min(380px, 78%);
  aspect-ratio: 1;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-illustration {
  width: 210px;
  max-width: 80%;
  height: auto;
  object-fit: contain;
  display: block;
}

.login-illustration-caption {
  margin-top: 22px;
  font-size: 16px;
  font-weight: 700;
  color: #35b558;
}

.login-btn {
  background: #35b558;
  color: #fff;
  border: none;
  font-weight: 600;
  height: 54px;
}

.login-btn:hover {
  background: #2da24e !important;
  color: #fff !important;
}

.eye-icon {
  position: absolute;
  right: 18px;
  top: 18px;
  color: #999;
}

/* Forgot Password Modal */
.forgot-password-modal .ant-modal-content {
  border-radius: 16px;
  overflow: hidden;
}

.forgot-password-modal .ant-modal-close {
  top: 16px;
  right: 16px;
}

.forgot-password-close-icon {
  color: #ff4d4f !important;
  font-size: 18px;
}

.forgot-password-content {
  padding: 18px 22px 22px;
}

.forgot-password-title {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 10px;
}

.forgot-password-subtitle {
  font-size: 13px;
  color: #8c8c8c;
  line-height: 1.45;
  margin-bottom: 16px;
}

.forgot-password-btn {
  width: 100%;
  height: 48px;
  border-radius: 999px;
  background: #35b558 !important;
  border-color: #35b558 !important;
  font-weight: 600;
  margin-top: 6px;
}

.forgot-password-btn:hover {
  background: #2da24e !important;
  border-color: #2da24e !important;
}

/* Verify OTP Modal */
.verify-otp-modal .ant-modal-content {
  border-radius: 16px;
  overflow: hidden;
}

.verify-otp-modal .ant-modal-close {
  top: 16px;
  right: 16px;
}

.verify-otp-close-icon {
  color: #ff4d4f !important;
  font-size: 18px;
}

.verify-otp-content {
  padding: 18px 22px 22px;
  text-align: left;
}

.verify-otp-title {
  font-size: 20px;
  font-weight: 800;
  color: #1a1a1a;
  margin-bottom: 10px;
}

.verify-otp-subtitle {
  font-size: 14px;
  color: #8c8c8c;
  line-height: 1.45;
  margin-bottom: 14px;
}

.verify-otp-email {
  color: #666;
  font-weight: 600;
}

.verify-otp-timer {
  text-align: center;
  color: #ff4d4f;
  font-weight: 700;
  margin: 6px 0 14px;
}

.verify-otp-inputs {
  display: flex;
  justify-content: center;
  gap: 14px;
  margin-bottom: 14px;
}

.verify-otp-box {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  border: 2px solid #f0f0f0;
  background: #f7f7f7;
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  outline: none;
}

.verify-otp-box:focus {
  border-color: #35b558;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(53, 181, 88, 0.15);
}

.verify-otp-box--filled {
  background: #35b558;
  border-color: #35b558;
  color: #fff;
}

.verify-otp-resend {
  width: 100%;
  text-align: center;
  background: transparent;
  border: none;
  color: #35b558;
  font-weight: 600;
  margin: 4px 0 18px;
  cursor: pointer;
}

.verify-otp-resend:disabled {
  color: #bfbfbf;
  cursor: not-allowed;
}

.verify-otp-verify-btn {
  width: 100%;
  height: 54px;
  border-radius: 999px;
  background: #35b558 !important;
  border-color: #35b558 !important;
  font-weight: 700;
  font-size: 16px;
}

.verify-otp-verify-btn:hover {
  background: #2da24e !important;
  border-color: #2da24e !important;
}

@media (max-width: 520px) {
  .verify-otp-inputs {
    gap: 10px;
  }

  .verify-otp-box {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    font-size: 18px;
  }
}

/* Password Changed Success Modal */
.password-changed-modal .ant-modal-content {
  padding: 0;
}

.password-changed-modal .ant-modal-close {
  top: 16px;
  right: 16px;
}

.password-changed-close-icon {
  color: #ff4d4f !important;
  font-size: 18px;
}

.password-changed-hero {
  position: relative;
  height: 170px;
  background: #eefcf2;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.password-changed-hero-wave {
  position: absolute;
  left: -10%;
  right: -10%;
  bottom: -44px;
  height: 120px;
  background: #fff;
  border-top-left-radius: 60% 80%;
  border-top-right-radius: 60% 80%;
}

.password-changed-hero-icon {
  width: 76px;
  height: 76px;
  border-radius: 50%;
  border: 3px solid #35b558;
  color: #35b558;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 34px;
  background: rgba(255, 255, 255, 0.9);
  position: relative;
}

.password-changed-content {
  padding: 24px 28px 32px;
  text-align: center;
}

.password-changed-title {
  font-size: 18px;
  font-weight: 800;
  color: #1a1a1a;
  margin-bottom: 8px;
}

.password-changed-subtitle {
  font-size: 14px;
  color: #8c8c8c;
  line-height: 1.45;
  margin-bottom: 22px;
}

.password-changed-btn {
  height: 48px;
  border-radius: 12px;
  background: #35b558 !important;
  border-color: #35b558 !important;
  font-weight: 700;
  padding: 0 22px;
}

.password-changed-btn:hover {
  background: #2da24e !important;
  border-color: #2da24e !important;
}

.divider {
  text-align: center;
  margin: 25px 0;
  color: #888;
  font-size: 12px;
}

.social-row {
  display: flex;
  gap: 12px;
}

.social-btn {
  width: 100%;
  border-radius: 14px;
  padding: 10px;
  font-size: 14px;
}

@media (max-width: 992px) {
  .login-card {
    flex-direction: column;
  }

  .login-left,
  .login-right {
    width: 100%;
  }

  .login-right {
    min-height: 360px;
  }

  .login-illustration {
    width: 180px;
  }
}

@media (max-width: 576px) {
  .login-illustration {
    width: 140px;
  }
}

/* Remove antd default border */
.custom-iy-input .ant-input,
.custom-iy-input .ant-input-password {
  border: none !important;
  box-shadow: none !important;
  height: 20px;
}

/* Shadow wrapper */
.input-shadow {
  background: #fff;
  border-radius: 50px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
}

/* Remove double border between select and input */
.country-code {
  border: none !important;
  background: transparent !important;
  max-width: 90px;
}

.input-shadow .ant-form-item {
  margin-bottom: 0 !important;
}

/* Compact input with shadow - fixes password field */
.compact-shadow-input .ant-input,
.compact-shadow-input .ant-input-password {
  border: 1px solid #f5f5f5 !important;
  /* remove default border */
  box-shadow: none !important;
  /* remove default ant shadow */
  height: 50px;
  /* smaller height */
  padding: 10px 15px !important;
  /* reduce padding */
  border-radius: 18px;
  /* slightly rounded */
  font-size: 14px;
  background: #fff;
  /* white background */
}

/* Shadow wrapper */
.compact-shadow-input .input-shadow {
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08) !important;
  /* subtle shadow */
  border-radius: 18px;
}

/* Fix Input.Password wrapper */
.compact-shadow-input .ant-input-affix-wrapper {
  height: 36px !important;
  /* same height for wrapper */
  padding: 0 15px !important;
  display: flex;
  align-items: center;
  border-radius: 18px;
}

/* Fix prefix/suffix icons */
.compact-shadow-input .ant-input-prefix,
.compact-shadow-input .ant-input-suffix {
  font-size: 16px;
  display: flex;
  align-items: center;
}

/* Add subtle shadow */
.compact-shadow-input .input-shadow {
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  border-radius: 18px;
}

.loginlink {
  text-decoration: none;
  color: #000;
}

.loginlink:hover {
  color: #2da24e;
}

/* Wrapper */
.product-card-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
}

/* Card */
.product-card {
  width: 100%;
  max-width: 360px;
  border-radius: 28px !important;
  box-shadow: 0 14px 40px rgba(15, 23, 42, 0.08) !important;
  background: #ffffff;
}

/* Image */
.product-image-wrapper {
  position: relative;
  border-radius: 26px;
  overflow: hidden;
  background: #f3f4f6;
  aspect-ratio: 4 / 3;
}

.product-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* Rating pill */
.product-rating {
  position: absolute;
  right: 14px;
  bottom: 14px;
  background: #ffffff;
  border-radius: 14px;
  padding: 6px 10px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);
  font-weight: 600;
  font-size: 13px;
}

.product-star {
  color: #f5b301;
  font-size: 14px;
}

/* Content */
.product-content {
  text-align: center;
  padding-top: 14px;
}

.product-title {
  margin: 8px 0 4px !important;
  font-weight: 500 !important;
  color: #1f2a44 !important;
}

/* Price */
.product-price-row {
  margin-bottom: 12px;
}

.product-currency {
  color: #ef4444;
  font-weight: 600;
  font-size: 18px;
}

.product-price {
  color: #0f172a;
  font-weight: 700;
  font-size: 26px;
}

.product-unit {
  color: #94a3b8;
  font-size: 14px;
}

/* Vendor */
.product-vendor-row {
  justify-content: center;
  width: 100%;
  margin-bottom: 18px;
}

.product-vendor-avatar {
  background: #fdecec !important;
  color: #ef4444 !important;
  font-weight: 700;
}

.product-vendor-name {
  color: #9ca3af;
  font-size: 14px;
}

/* Button */
.product-add-btn {
  height: 52px !important;
  border-radius: 999px !important;
  background: #22c55e !important;
  border-color: #22c55e !important;
  font-weight: 600 !important;
  box-shadow: 0 12px 22px rgba(34, 197, 94, 0.25);
}

.product-add-btn:hover,
.product-add-btn:focus {
  background: #16a34a !important;
  border-color: #16a34a !important;
}

/* Responsive tweaks */
@media (max-width: 480px) {
  .product-card {
    max-width: 100%;
    border-radius: 24px !important;
  }

  .product-image-wrapper {
    border-radius: 22px;
  }
}


/* Header */
.iye-header {
  width: 100%;
  background: #2fbf55;
}

.iye-header__container {
  height: 85px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 0 28px;
}

/* Brand */
.iye-brand {
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 180px;
}

.iye-brand__img {
  height: 48px;
  width: auto;
  max-width: 140px;
  object-fit: contain;
  display: block;
}

.iye-brand__text {
  font-weight: 800;
  letter-spacing: 1px;
  font-size: 56px;
  line-height: 1;
  color: #ffffff;
}

.iye-brand__mark {
  width: 66px;
  height: 66px;
  display: grid;
  place-items: center;
}

/* Bag icon */
.iye-bag {
  position: relative;
  width: 44px;
  height: 44px;
}

.iye-bag__handle {
  position: absolute;
  top: 4px;
  left: 10px;
  width: 24px;
  height: 16px;
  border: 4px solid #ffffff;
  border-bottom: 0;
  border-radius: 16px 16px 0 0;
  opacity: 0.95;
}

.iye-bag__body {
  position: absolute;
  top: 16px;
  left: 8px;
  width: 28px;
  height: 26px;
  background: #ffffff;
  border-radius: 10px;
}

.iye-bag__leaves {
  position: absolute;
  top: -2px;
  left: -2px;
  width: 52px;
  height: 18px;
  display: flex;
  gap: 4px;
  align-items: flex-end;
}

.iye-leaf {
  width: 10px;
  height: 14px;
  border-radius: 12px 12px 12px 0;
  transform: rotate(-20deg);
}

.iye-leaf--1 {
  background: #ff3b3b;
}

.iye-leaf--2 {
  background: #ffa800;
  transform: rotate(5deg);
}

.iye-leaf--3 {
  background: #ffd400;
  transform: rotate(25deg);
}

/* Nav */
.iye-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 56px;
  flex: 1 1;
}

.iye-nav__link {
  background: transparent;
  border: 0;
  color: #ffffff;
  font-weight: 700;
  font-size: 16px;
  cursor: pointer;
  padding: 10px 8px;
  border-radius: 14px;
  transition: background 160ms ease, transform 160ms ease;
}

.iye-nav__link:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-1px);
}

/* Actions */
.iye-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  min-width: 520px;
}

.iye-pill {
  appearance: none;
  border: 2px solid rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
  border-radius: 8px;
  padding: 12px 10px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 12px;
  transition: background 160ms ease, transform 160ms ease;
}

.iye-pill:hover {
  background: rgba(255, 255, 255, 0.14);
  transform: translateY(-1px);
}

.iye-pill__caret {
  font-size: 14px;
  opacity: 0.95;
}

.iye-pill__flag {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  background: rgba(255, 255, 255, 0.18);
  border-radius: 999px;
  font-size: 18px;
}

.iye-pill__currency {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.1;
}

.iye-pill__currencyCode {
  font-weight: 800;
  font-size: 18px;
}

.iye-pill__rate {
  font-weight: 700;
  font-size: 14px;
  opacity: 0.95;
}

.iye-pill__icon {
  font-size: 22px;
}

.iye-pill__cartTotal {
  font-weight: 800;
  font-size: 18px;
}

.iye-pill__langIcon {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.18);
  font-weight: 800;
  font-size: 14px;
}

.iye-pill__langText {
  font-weight: 800;
  font-size: 18px;
}

/* Hamburger */
.iye-hamburger {
  width: 62px;
  height: 62px;
  border-radius: 999px;
  border: 0;
  background: #ffffff;
  color: #111111;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  display: grid;
  place-items: center;
  cursor: pointer;
  transition: transform 160ms ease;
}

.iye-hamburger:hover {
  transform: translateY(-1px);
}

/* Responsive */
@media (max-width: 1200px) {
  .iye-header__container {
    height: 96px;
    padding: 0 18px;
  }

  .iye-brand__text {
    font-size: 46px;
  }

  .iye-nav__link {
    font-size: 22px;
  }

  .iye-actions {
    min-width: 420px;
  }
}

@media (max-width: 992px) {
  .iye-nav {
    display: none;
  }

  .iye-actions {
    min-width: unset;
    gap: 12px;
  }

  .iye-pill {
    padding: 10px 12px;
    border-radius: 16px;
  }

  .iye-pill__langText {
    display: none;
  }
}

@media (max-width: 640px) {
  .iye-header__container {
    height: 86px;
    gap: 12px;
    padding: 0 12px;
  }

  .iye-brand {
    min-width: unset;
    gap: 12px;
  }

  .iye-brand__text {
    font-size: 38px;
  }

  .iye-pill--currency .iye-pill__rate {
    display: none;
  }

  .iye-pill__flag {
    width: 30px;
    height: 30px;
  }

  .iye-hamburger {
    width: 54px;
    height: 54px;
  }
}

/* global.css (plain CSS) */

/* Wrapper matches dark bar look */
.pticker {
  width: 100%;
  background: #000000;
  padding: 10px 0;
}

/* container fluid already gives width; keep padding similar to screenshot */
.pticker__container {
  padding-left: 18px;
  padding-right: 18px;
}

.pticker__viewport {
  position: relative;
  overflow: hidden;
  width: 100%;
}

/* Track: continuous movement */
.pticker__track {
  display: flex;
  align-items: center;
  width: max-content;
  animation: pticker-marquee var(--pticker-speed, 28s) linear infinite;
  will-change: transform;
}

/* Pause on hover (optional) */
.pticker--pause .pticker__viewport:hover .pticker__track {
  animation-play-state: paused;
}

/* Each item */
.pticker__item {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 4px 18px;
  white-space: nowrap;
}

.pticker__text {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 140px;
}

.pticker__title {
  color: rgba(255, 255, 255, 0.92);
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.2px;
}

.pticker__meta {
  display: flex;
  align-items: center;
  gap: 12px;
}

.pticker__price {
  color: rgba(255, 255, 255, 0.75);
  font-size: 15px;
  font-weight: 500;
}

.pticker__change {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
}

/* colored arrow badge */
.pticker__badge {
  width: 24px;
  height: 24px;
  border-radius: 999px;
  display: inline-grid;
  place-items: center;
  font-size: 12px;
}

.pticker__change.is-up {
  color: #34d399;
  /* green-ish */
}

.pticker__change.is-up .pticker__badge {
  background: #059669;
  /* darker green */
  color: #ffffff;
}

.pticker__change.is-down {
  color: #fb7185;
  /* red-ish */
}

.pticker__change.is-down .pticker__badge {
  background: #e11d48;
  /* darker red */
  color: #ffffff;
}

.pticker__changeText {
  opacity: 0.95;
}

/* vertical separator like the screenshot */
.pticker__sep {
  width: 1px;
  height: 38px;
  background: rgba(255, 255, 255, 0.18);
}

/* seamless marquee:
   Because we duplicate items, moving half the track width gives a perfect loop */
@keyframes pticker-marquee {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}

/* Accessibility: screen reader only block */
.pticker__sr {
  position: absolute;
  left: -9999px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
}

/* Responsive tweaks */
@media (max-width: 992px) {
  .pticker__title {
    font-size: 16px;
  }

  .pticker__price,
  .pticker__change {
    font-size: 13px;
  }

  .pticker__item {
    padding: 4px 14px;
    gap: 14px;
  }

  .pticker__sep {
    height: 34px;
  }
}

@media (max-width: 576px) {
  .pticker__container {
    padding-left: 12px;
    padding-right: 12px;
  }

  .pticker__title {
    font-size: 15px;
  }

  .pticker__text {
    min-width: 120px;
  }

  .pticker__badge {
    width: 22px;
    height: 22px;
  }
}

/* ========== Dashboard (Main Dashboard) ========== */
.dashboard-wrap {
  background: #f4f7f6;
  min-height: 100%;
  border-top-left-radius: 20px;
}

.dashboard-top-bar {
  background: #fff;
  box-shadow: none;
  padding: 24px 0;
  margin-bottom: 12px;
}

.dashboard-top-bar-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  max-width: 100%;
  padding: 0 32px;
  margin: 0;
}

.dashboard-top-bar-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.dashboard-top-bar-right {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: nowrap;
  flex-direction: row;
}

.dashboard-header {
  padding: 0;
}

.dashboard-welcome {
  font-size: 13px;
  color: #888;
  font-weight: 500;
  margin-bottom: 4px !important;
}

.dashboard-title {
  font-size: 22px;
  font-weight: 600;
  color: #1a1a1a;
}

.dashboard-header-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  flex-wrap: wrap;
}

.dashboard-search-input {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 8px 16px;
  width: 280px;
}

.dashboard-search-input input {
  background: transparent;
}

.dashboard-avatar {
  background: #d9d9d9;
  color: #555;
  cursor: pointer;
}

/* KPI cards */
.dashboard-kpi-card {
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02);
  background: #fff;
  padding: 0;
  height: 110px;
}

.dashboard-kpi-card .ant-card-body {
  padding: 24px;
}

.dashboard-kpi-row {
  display: flex;
  align-items: center;
  gap: 20px;
}

.dashboard-kpi-icon-wrap {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  flex: 0 0 auto;
}

.dashboard-kpi-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.dashboard-kpi-value {
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.2;
}

.dashboard-kpi-label {
  font-size: 13px;
  color: #888;
  font-weight: 500;
  margin-top: 4px;
}

.dashboard-kpi-meta {
  color: #35b558;
  font-size: 12px;
  font-weight: 600;
  margin-top: 6px;
}

.dashboard-summary-error {
  border-radius: 10px;
}

/* Chart card */
.dashboard-chart-card {
  border-radius: 24px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.02);
  background: #fff;
  margin-top: 8px;
}

.dashboard-chart-card .ant-card-body {
  padding: 32px;
}

.dashboard-chart-header {
  margin-bottom: 24px;
}

.dashboard-chart-title-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.dashboard-chart-title {
  font-weight: 500;
  font-size: 18px;
  color: #92a3c2;
}

.dashboard-chart-title-icon-btn {
  background: #35b558;
  width: 26px;
  height: 26px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dashboard-chart-big-value {
  font-size: 32px;
  font-weight: 700;
  color: #1d253b;
  line-height: 1;
}

.dashboard-chart-market-name {
  color: #92a3c2;
  font-size: 13px;
  font-weight: 500;
  margin-top: 8px;
}

.dashboard-chart-year-btn {
  border-radius: 10px;
  font-size: 14px;
  color: #555;
  border: 1px solid #eaeaea;
  padding: 6px 16px;
  height: 40px;
  font-weight: 500;
}

.dashboard-chart-inner {
  width: 100%;
  min-height: 320px;
  position: relative;
}

.dashboard-chart-state {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 320px;
}

.dashboard-chart-error {
  align-items: center;
  color: #d4380d;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-weight: 500;
  gap: 12px;
}

.dashboard-chart-empty-note {
  color: #92a3c2;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 8px;
  text-align: center;
}

.dashboard-chart-tooltip {
  background: #00c2e0;
  color: #fff;
  padding: 8px 16px;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 194, 224, 0.3);
  font-weight: 600;
  font-size: 14px;
  position: relative;
}

.dashboard-chart-tooltip::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  width: 8px;
  height: 8px;
  background: #00c2e0;
}

/* ========== Markets module ========== */
.markets-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  gap: 16px;
  padding: 0;
}

.markets-heading {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
}

.markets-toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;
}

.markets-search {
  width: 200px;
  min-width: 160px;
  border-radius: 999px;
}

.markets-search .ant-input-affix-wrapper {
  border-radius: 999px;
}

.markets-search-icon {
  color: #35b558;
}

.markets-add-btn {
  background: #35b558;
  border-color: #35b558;
  border-radius: 10px;
  height: 45px;
  font-weight: 600;
}

.markets-add-btn:hover {
  background: #2da24e !important;
  border-color: #2da24e !important;
  color: #fff !important;
}

/* Portal-wide slightly round buttons */
.adminpanel-layout .ant-btn {
  border-radius: 10px;
}

/* Portal-wide round inputs in modals */
.input-round.ant-input,
.input-round .ant-input {
  border-radius: 12px;
}

.textarea-round.ant-input {
  border-radius: 12px;
}

.markets-search-full {
  width: 100%;
  max-width: 100%;
}

.markets-search-full .ant-input-affix-wrapper {
  width: 100%;
}

.markets-empty-wrap {
  padding: 48px 24px;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  min-height: calc(100vh - 220px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.markets-empty-wrap:has(.markets-card-grid) {
  align-items: flex-start;
  justify-content: flex-start;
}

/* Markets list grid */
.markets-card-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  width: 100%;
}

.market-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  min-width: 0;
}

.market-card-logo {
  width: 56px;
  height: 56px;
  min-width: 56px;
  min-height: 56px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.market-card-logo-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.market-card-logo-icon {
  font-size: 28px;
}

.market-card-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.market-card-info {
  min-width: 0;
}

.market-card-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.market-card-title-row .market-card-name {
  margin-bottom: 0;
}

.market-card-status-tag {
  border-radius: 6px;
  font-size: 11px;
  line-height: 18px;
  padding: 0 6px;
  margin-right: 0;
}

.market-card-name {
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 4px;
}

.market-status-radio-group .ant-radio-button-wrapper {
  border-radius: 8px;
  margin-right: 8px;
  border-inline-start-width: 1px;
}

.market-status-radio-group .ant-radio-button-wrapper:first-child {
  border-radius: 8px;
}

.market-status-radio-group .ant-radio-button-wrapper:last-child {
  border-radius: 8px;
  margin-right: 0;
}

.market-status-radio-group .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  border-color: #35b558 !important;
  color: #35b558 !important;
  background-color: #f6ffed !important;
}

.market-card-location {
  font-size: 13px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 6px;
}

.market-card-description {
  color: #8c8c8c;
  display: -webkit-box;
  font-size: 12px;
  line-height: 1.35;
  margin-top: 4px;
  max-width: 360px;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.market-card-pin {
  font-size: 12px;
  color: #35b558;
  flex-shrink: 0;
}

.market-card-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.market-card-btn-edit {
  color: #1890ff;
  background: #e6f7ff;
  border-radius: 8px;
  font-size: 13px;
}

.market-card-btn-edit:hover {
  color: #1890ff;
  background: #bae7ff !important;
}

.market-card-btn-view {
  color: #35b558;
  background: #f6ffed;
  border-radius: 8px;
  font-size: 13px;
}

.market-card-btn-view:hover {
  color: #35b558;
  background: #d9f7be !important;
}

.market-card-btn-delete {
  color: #ff4d4f;
  background: #fff2f0;
  border-radius: 8px;
  font-size: 13px;
}

/* Market Stores page */
.market-stores-heading-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
}

.market-stores-back {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  color: #1a1a1a;
}

.market-stores-back:hover {
  background: #e8e8e8;
  color: #1a1a1a;
}

.market-stores-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.market-stores-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.market-stores-card-right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  white-space: nowrap;
}

.market-stores-card-left {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  min-width: 0;
}

.market-stores-card-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: #e8f5e9;
  color: #35b558;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
}

.market-stores-card-image {
  overflow: hidden;
}

.market-stores-card-image img {
  height: 100%;
  object-fit: cover;
  width: 100%;
}

.market-stores-card-info {
  min-width: 0;
}

.market-stores-card-name {
  font-size: 14px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 2px;
}

.market-stores-card-owner,
.market-stores-card-address {
  font-size: 12px;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.market-stores-status {
  font-size: 12px;
  font-weight: 600;
  color: #2e7d32;
  background: #e8f5e9;
  border-radius: 999px;
  padding: 6px 10px;
  flex-shrink: 0;
}

.market-stores-status--inactive {
  color: #ad6800;
  background: #fff7e6;
}

.market-stores-btn-review {
  background: #f5f5f5;
  border-color: #e8e8e8;
  color: #1a1a1a;
}

.market-stores-btn-review:hover {
  background: #e8e8e8 !important;
  border-color: #e8e8e8 !important;
  color: #1a1a1a !important;
}

@media (max-width: 768px) {
  .market-stores-grid {
    grid-template-columns: 1fr;
  }
}

.market-card-btn-delete:hover {
  color: #ff4d4f;
  background: #ffccc7 !important;
}

/* Rap card (uses Markets card base styles) */
.rap-card-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  font-size: 13px;
  color: #666;
}

.rap-card-meta-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.rap-card-meta-item .anticon {
  color: #35b558;
  font-size: 12px;
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .markets-card-grid {
    grid-template-columns: 1fr;
  }
}

.markets-empty-wrap .ant-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.markets-empty-wrap .ant-empty-image {
  margin-bottom: 0;
  flex-shrink: 0;
}

.markets-empty-wrap .ant-empty-description {
  margin-top: 24px;
  flex-shrink: 0;
}

.markets-empty-illustration {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 220px;
  box-sizing: border-box;
}

.markets-empty-phone {
  position: relative;
  width: 120px;
  height: 200px;
  border: 3px solid #35b558;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.markets-empty-bubble {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #35b558;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  left: 28px;
  top: -20px;
}

.markets-empty-store-icon {
  font-size: 28px;
  color: #fff;
}

.markets-empty-dot {
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #35b558;
  opacity: 0.6;
}

.markets-empty-dot-1 {
  top: 20px;
  right: 12px;
}

.markets-empty-dot-2 {
  bottom: 40px;
  left: 10px;
  background: #2196F3;
}

.markets-empty-dot-3 {
  bottom: 80px;
  right: 8px;
  width: 6px;
  height: 6px;
}

.markets-empty-star {
  position: absolute;
  font-size: 12px;
  color: #35b558;
  opacity: 0.8;
}

.markets-empty-star-1 {
  top: 40px;
  left: 8px;
}

.markets-empty-star-2 {
  bottom: 60px;
  right: 16px;
  color: #2196F3;
}

.markets-empty-text {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.markets-empty-title {
  font-size: 12px;
  font-weight: 500;
  color: #1a1a1a;
  margin-bottom: 2px;
}

.markets-empty-subtitle {
  font-size: 14px;
  color: #666;
  margin-top: 0;
  display: block;
}

/* Add Mart Modal */
/* Add Mart Modal - round corners */
.modal-round .ant-modal-content {
  border-radius: 16px;
  overflow: hidden;
}

.modal-round .ant-modal-header {
  border-bottom: 1px solid #f0f0f0;
  border-radius: 16px 16px 0 0;
}

.add-mart-modal .ant-modal-header {
  border-bottom: 1px solid #f0f0f0;
}

/* Single upload box: placeholder and preview live in the same rounded box */
.add-mart-upload-box {
  width: 160px;
  height: 160px;
  margin: 0 auto;
  border-radius: 50%;
  border: 1px solid #e8e8e8;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
}

.add-mart-upload-box .ant-upload {
  width: 100%;
  height: 100%;
  margin: 0;
}

.add-mart-upload-box .ant-upload-select {
  width: 100%;
  height: 100%;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
}

.add-mart-upload-box .ant-upload-select:hover {
  background: #ebebeb;
}

.add-mart-upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  text-align: center;
  cursor: pointer;
  width: 100%;
  height: 100%;
}

.add-mart-upload-icon {
  font-size: 40px;
  color: #bfbfbf;
  margin-bottom: 8px;
}

.add-mart-upload-text {
  font-size: 12px;
  color: #8c8c8c;
  line-height: 1.2;
}

.add-mart-upload-preview {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
}

.add-mart-upload-preview-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.add-mart-upload-remove {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  padding: 0;
  transition: background 0.2s;
  z-index: 1;
}

.add-mart-upload-remove:hover {
  background: rgba(0, 0, 0, 0.7);
}

.add-mart-upload .ant-upload-list-item-container,
.add-mart-upload .ant-upload-list-item {
  border-radius: 12px;
}

.add-mart-modal-footer {
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
  width: 100%;
}

.add-mart-modal-footer .ant-form-item-control {
  width: 100%;
  max-width: 100%;
}

.add-mart-modal-footer .ant-form-item-control-input-content {
  display: block;
  width: 100%;
  max-width: 100%;
}

.add-mart-modal .markets-add-btn {
  width: 100%;
  min-width: 0;
  height: 45px;
  display: block;
}

.market-location-form-item {
  margin-bottom: 20px;
}

.market-location-picker {
  background: #f8fbf9;
  border: 1px solid #e7f3eb;
  border-radius: 16px;
  padding: 16px;
}

.market-location-picker-head {
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.market-location-picker-title {
  color: #1f1f1f;
  font-size: 16px;
  font-weight: 700;
}

.market-location-picker-subtitle {
  color: #8c8c8c;
  font-size: 13px;
  line-height: 1.5;
  margin-top: 3px;
}

.market-location-picker-alert {
  border-radius: 10px;
  margin-bottom: 12px;
}

.market-location-search .ant-input,
.market-location-search .ant-input-group-addon .ant-btn {
  height: 44px;
}

.market-location-search .ant-input {
  border-radius: 12px 0 0 12px;
}

.market-location-search .ant-input-search-button {
  background: #35b558 !important;
  border-color: #35b558 !important;
  border-radius: 0 12px 12px 0 !important;
  font-weight: 600;
}

.market-location-results {
  background: #fff;
  border: 1px solid #edf2ef;
  border-radius: 12px;
  box-shadow: 0 8px 22px rgba(16, 24, 40, 0.08);
  margin-top: 8px;
  max-height: 190px;
  overflow: auto;
}

.market-location-result {
  align-items: flex-start;
  background: transparent;
  border: 0;
  border-bottom: 1px solid #f2f4f3;
  color: #4d5a52;
  cursor: pointer;
  display: flex;
  gap: 10px;
  line-height: 1.45;
  padding: 10px 12px;
  text-align: left;
  width: 100%;
}

.market-location-result:last-child {
  border-bottom: 0;
}

.market-location-result:hover {
  background: #f4fbf6;
  color: #2e7d32;
}

.market-location-result .anticon {
  color: #35b558;
  flex: 0 0 auto;
  margin-top: 3px;
}

.market-location-map-wrap {
  background: #eef4f0;
  border: 1px solid #e1ece5;
  border-radius: 14px;
  height: 300px;
  margin-top: 14px;
  overflow: hidden;
  position: relative;
}

.market-location-map {
  height: 100%;
  width: 100%;
}

.market-location-map-state {
  align-items: center;
  display: flex;
  inset: 0;
  justify-content: center;
  position: absolute;
  z-index: 1;
}

.market-location-coordinates {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-top: 14px;
}

.market-location-coordinates div {
  background: #fff;
  border: 1px solid #edf2ef;
  border-radius: 12px;
  padding: 10px 12px;
}

.market-location-coordinates span {
  color: #8c8c8c;
  display: block;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 4px;
}

.market-location-coordinates strong {
  color: #1f1f1f;
  display: block;
  font-size: 14px;
  font-weight: 700;
}

@media (max-width: 575px) {
  .market-location-picker {
    padding: 12px;
  }

  .market-location-map-wrap {
    height: 260px;
  }

  .market-location-coordinates {
    grid-template-columns: 1fr;
  }
}

/* Delete Mart Modal */
.delete-mart-modal .ant-modal-content {
  padding: 0;
}

.delete-mart-modal .ant-modal-close {
  top: 16px;
  right: 16px;
}

.delete-mart-close-icon {
  color: #ff4d4f !important;
  font-size: 18px;
}

.delete-mart-hero {
  position: relative;
  height: 180px;
  background: #fff2f0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.delete-mart-hero-icon {
  width: 72px;
  height: 72px;
  border-radius: 18px;
  background: #ffe4e6;
  color: #ff4d4f;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 34px;
}

.delete-mart-hero-wave {
  position: absolute;
  left: -10%;
  right: -10%;
  bottom: -40px;
  height: 120px;
  background: #fff;
  border-top-left-radius: 60% 80%;
  border-top-right-radius: 60% 80%;
}

.delete-mart-content {
  padding: 28px 28px 32px;
  text-align: center;
}

.delete-mart-title {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 8px;
}

.delete-mart-subtitle {
  font-size: 14px;
  color: #8c8c8c;
  line-height: 1.45;
  margin-bottom: 22px;
}

.delete-mart-btn {
  width: 70%;
  max-width: 360px;
  border-radius: 999px;
  height: 44px;
  font-weight: 600;
}

.market-detail {
  display: grid;
  gap: 18px;
}

.market-detail-loading {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 240px;
}

.market-detail-logo {
  border-radius: 12px;
  height: 220px !important;
  object-fit: cover;
  width: 100% !important;
}

/* ========== Store Approval module ========== */
.store-approval-card {
  background: transparent;
}

.store-approval-card-header {
  margin-bottom: 10px;
}

.store-approval-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a1a;
}

.store-approval-count {
  font-weight: 500;
  color: #666;
  margin-left: 4px;
}

.store-approval-tabs {
  display: flex;
  gap: 14px;
  align-items: center;
  margin: 10px 0 18px;
  flex-wrap: wrap;
}

.store-approval-tab {
  height: 40px;
  padding: 0 18px;
  border-radius: 10px;
  border: 1px solid #f0f0f0;
  background: #fff;
  color: #666;
  font-weight: 600;
}

.store-approval-tab--active {
  background: #35b558 !important;
  border-color: #35b558 !important;
  color: #fff !important;
}

.store-approval-tab-count {
  margin-left: 6px;
  font-weight: 500;
  opacity: 0.9;
}

.store-approval-body {
  min-height: calc(100vh - 260px);
}

.store-approval-loading {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 280px;
}

.store-approval-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  width: 100%;
}

.store-approval-item-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  min-width: 0;
}

.store-approval-item-logo-wrap {
  position: relative;
  flex-shrink: 0;
}

.store-approval-item-logo {
  width: 58px;
  height: 58px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.store-approval-item-logo-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  font-size: 18px;
  color: #52c41a;
  background: #fff;
  border-radius: 50%;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.store-approval-item-logo-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.store-approval-item-logo-icon {
  font-size: 26px;
  color: #35b558;
}

.store-approval-item-mid {
  flex: 1 1;
  min-width: 0;
}

.store-approval-item-name {
  font-size: 14px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 6px;
}

.store-approval-item-owner {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #666;
  font-size: 12px;
}

.store-approval-item-owner-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 160px;
}

.store-approval-item-actions {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
}

.store-approval-btn {
  height: 32px;
  padding: 0 14px;
  border-radius: 10px;
  border: none;
  font-weight: 600;
  font-size: 12px;
}

.store-approval-btn-approve {
  background: #eafff1;
  color: #35b558;
}

.store-approval-btn-approve:hover {
  background: #d4ffe3 !important;
  color: #2da24e !important;
}

.store-approval-btn-decline {
  background: #fff0f0;
  color: #ff4d4f;
}

.store-approval-btn-decline:hover {
  background: #ffd6d6 !important;
  color: #ff4d4f !important;
}

.store-approval-btn-review {
  background: #f5f5f5;
  color: #1a1a1a;
}

.store-approval-btn-review:hover {
  background: #e8e8e8 !important;
  color: #1a1a1a !important;
}

.store-approval-item-card .store-approval-item-mid[role="button"],
.store-approval-item-card .store-approval-item-logo-wrap[role="button"] {
  cursor: pointer;
}

/* Store Review Drawer */
.store-review-drawer .ant-drawer-content-wrapper {
  box-shadow: -4px 0 16px rgba(0, 0, 0, 0.08);
}

/* Store Approve/Decline confirmation modal (matches project style) */
.store-action-modal .ant-modal-content {
  padding: 0;
}

.store-action-modal .ant-modal-close {
  top: 16px;
  right: 16px;
}

.store-action-close-icon {
  color: #ff4d4f !important;
  font-size: 18px;
}

.store-action-hero {
  position: relative;
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.store-action-modal--approve .store-action-hero {
  background: #f6ffed;
}

.store-action-modal--decline .store-action-hero {
  background: #fff2f0;
}

.store-action-hero-icon {
  width: 72px;
  height: 72px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 34px;
}

.store-action-modal--approve .store-action-hero-icon {
  background: #e8f5e9;
  color: #35b558;
}

.store-action-modal--decline .store-action-hero-icon {
  background: #ffe4e6;
  color: #ff4d4f;
}

.store-action-hero-wave {
  position: absolute;
  left: -10%;
  right: -10%;
  bottom: -40px;
  height: 120px;
  background: #fff;
  border-top-left-radius: 60% 80%;
  border-top-right-radius: 60% 80%;
}

.store-action-content {
  padding: 28px 28px 32px;
  text-align: center;
}

.store-action-title {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 8px;
}

.store-action-subtitle {
  font-size: 14px;
  color: #8c8c8c;
  line-height: 1.45;
  margin-bottom: 22px;
}

.store-action-btn {
  width: 70%;
  max-width: 360px;
  border-radius: 999px;
  height: 44px;
  font-weight: 600;
  border: none;
}

.store-action-btn--approve {
  background: #35b558 !important;
}

.store-action-btn--approve:hover {
  background: #2da24e !important;
}

.store-action-btn--decline {
  background: #ff4d4f !important;
}

.store-action-btn--decline:hover {
  background: #ff7875 !important;
}

.store-review-drawer-inner {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.store-review-header {
  position: relative;
  padding: 20px 24px 24px;
  background: linear-gradient(135deg, #2e7d32 0%, #388e3c 50%, #43a047 100%);
  border-radius: 0;
}

.store-review-header-pattern {
  position: absolute;
  inset: 0;
  opacity: 0.08;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.store-review-profile {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
}

.store-review-logo {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}

.store-review-logo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.store-review-logo-icon {
  font-size: 24px;
  color: rgba(0, 0, 0, 0.6);
}

.store-review-profile-text {
  min-width: 0;
}

.store-review-approved-tag {
  margin-top: 8px;
  border-radius: 999px;
  font-weight: 600;
}

.store-review-store-name {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 4px;
}

.store-review-owner {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.9);
}

.store-review-owner .ant-avatar {
  flex-shrink: 0;
}

.store-review-section {
  padding: 16px 24px;
  border-bottom: 1px solid #f0f0f0;
}

.store-review-section:last-of-type {
  border-bottom: none;
}

.store-review-section-label {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #666;
  margin-bottom: 8px;
}

.store-review-privacy {
  font-size: 12px;
  line-height: 1.5;
  color: #666;
  margin: 0;
}

.store-review-docs {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.store-review-doc-card {
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  overflow: hidden;
  background: #fafafa;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 118px;
}

.store-review-doc-title {
  width: 100%;
  padding: 7px 8px;
  background: #f6ffed;
  color: #2e7d32;
  font-size: 11px;
  font-weight: 700;
  text-align: center;
}

.store-review-doc-card a {
  display: block;
  width: 100%;
  flex: 1 1;
  min-height: 88px;
}

.store-review-doc-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.store-review-doc-placeholder {
  flex: 1 1;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #999;
  text-align: center;
  padding: 12px;
}

.store-review-state {
  min-height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 12px;
  color: #8c8c8c;
}

.store-review-owner-grid {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.store-review-owner-row {
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 8px;
  font-size: 13px;
}

.store-review-owner-label {
  color: #666;
}

.store-review-owner-value {
  color: #1a1a1a;
  word-break: break-word;
}

.store-review-footer {
  margin-top: auto;
  padding: 16px 24px 24px;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.store-review-footer-decline {
  background: #fff0f0;
  color: #ff4d4f;
  border-color: #ff4d4f;
}

.store-review-footer-decline:hover {
  background: #ffd6d6 !important;
  color: #ff4d4f !important;
  border-color: #ff4d4f !important;
}

.store-review-footer-approve {
  background: #2e7d32 !important;
  border-color: #2e7d32 !important;
}

.store-review-footer-approve:hover {
  background: #388e3c !important;
  border-color: #388e3c !important;
}

@media (max-width: 768px) {
  .store-approval-grid {
    grid-template-columns: 1fr;
  }

  .store-review-docs {
    grid-template-columns: 1fr;
  }
}

/* ========== Product Category ========== */
.product-category-card {
  background: transparent;
}

.product-category-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 20px;
}

.product-category-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a1a;
}

.product-category-count {
  font-weight: 500;
  color: #666;
  margin-left: 4px;
}

.product-category-create-btn {
  background: #35b558 !important;
  border-color: #35b558 !important;
  font-weight: 500;
  height: 45px;
}

.product-category-create-btn:hover {
  background: #2e9d4a !important;
  border-color: #2e9d4a !important;
}

/* ========== Add Rap ========== */
.raps-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  padding: 16px;
}

.raps-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.raps-card-title {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
}

.raps-card-count {
  font-weight: 500;
  color: #666;
}

.product-category-body {
  min-height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.product-category-loading {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 320px;
  width: 100%;
}

.product-category-body .ant-empty {
  padding: 24px 0;
}

.product-category-body .ant-empty-description {
  margin-top: 24px;
}

/* Product Category grid and cards */
.product-category-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 20px;
  width: 100%;
}

.product-category-item-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.product-category-item-image {
  width: 100%;
  aspect-ratio: 1;
  max-width: 140px;
  margin: 0 auto 12px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.product-category-item-image-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-category-item-icon {
  font-size: 48px;
  line-height: 1;
}

.product-category-item-name {
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 12px;
}

.product-category-item-actions {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
}

.product-category-item-btn {
  width: 36px !important;
  height: 36px !important;
  padding: 0 !important;
  border-radius: 50% !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.product-category-item-btn-edit {
  color: #1890ff !important;
  background: #e6f7ff !important;
}

.product-category-item-btn-edit:hover {
  color: #1890ff !important;
  background: #bae7ff !important;
}

.product-category-item-btn-delete {
  color: #ff4d4f !important;
  background: #fff2f0 !important;
}

.product-category-item-btn-delete:hover {
  color: #ff4d4f !important;
  background: #ffccc7 !important;
}

/* Product Category empty state illustration */
.product-category-empty-illustration {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 220px;
  box-sizing: border-box;
}

.product-category-empty-phone {
  position: relative;
  width: 120px;
  height: 200px;
  border: 3px solid #35b558;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.product-category-empty-bubble {
  position: absolute;
  inset: 12px;
  border-radius: 16px;
  background: linear-gradient(145deg, #52c41a 0%, #35b558 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.1);
}

.product-category-empty-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 6px;
  padding: 8px;
}

.product-category-empty-icon {
  width: 18px;
  height: 18px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 4px;
}

.product-category-empty-sparkle {
  position: absolute;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.9);
}

.product-category-empty-sparkle-1 {
  top: 8px;
  right: 10px;
}

.product-category-empty-sparkle-2 {
  bottom: 10px;
  left: 8px;
}

.product-category-empty-dot {
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #35b558;
  opacity: 0.6;
}

.product-category-empty-dot-1 {
  top: 20px;
  right: 12px;
}

.product-category-empty-dot-2 {
  bottom: 40px;
  left: 10px;
  background: #2196F3;
}

.product-category-empty-dot-3 {
  bottom: 80px;
  right: 8px;
  width: 6px;
  height: 6px;
}

.product-category-empty-star {
  position: absolute;
  font-size: 12px;
  color: #35b558;
  opacity: 0.8;
}

.product-category-empty-star-1 {
  top: 40px;
  left: 8px;
}

.product-category-empty-star-2 {
  bottom: 60px;
  right: 16px;
  color: #2196F3;
}

.product-category-empty-text {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.product-category-empty-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 8px;
}

.product-category-empty-subtitle {
  font-size: 14px;
  color: #666;
  margin: 0;
}

/* Add Category Modal */
.add-category-close-icon {
  color: #ff4d4f !important;
  font-size: 18px;
}

.add-category-modal .ant-modal-header {
  border-bottom: 1px solid #f0f0f0;
}

.add-category-modal-footer {
  margin-bottom: 0;
}

.add-category-submit-btn {
  width: 100%;
  background: #35b558 !important;
  border-color: #35b558 !important;
  font-weight: 500;
  height: 48px;
  font-size: 16px;
}

.add-category-submit-btn:hover {
  background: #2e9d4a !important;
  border-color: #2e9d4a !important;
}

/* Delete Category (confirm) Modal */
.delete-category-modal .ant-modal-content {
  padding: 0;
}

.delete-category-modal .ant-modal-close {
  top: 16px;
  right: 16px;
}

.delete-category-close-icon {
  color: #ff4d4f !important;
  font-size: 18px;
}

.delete-category-hero {
  position: relative;
  height: 180px;
  background: #fff2f0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.delete-category-hero-icon {
  width: 72px;
  height: 72px;
  border-radius: 18px;
  background: #ffe4e6;
  color: #ff4d4f;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 34px;
}

.delete-category-hero-wave {
  position: absolute;
  left: -10%;
  right: -10%;
  bottom: -40px;
  height: 120px;
  background: #fff;
  border-top-left-radius: 60% 80%;
  border-top-right-radius: 60% 80%;
}

.delete-category-content {
  padding: 28px 28px 32px;
  text-align: center;
}

.delete-category-title {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 8px;
}

.delete-category-subtitle {
  font-size: 14px;
  color: #8c8c8c;
  line-height: 1.45;
  margin-bottom: 22px;
}

.delete-category-btn {
  width: 70%;
  max-width: 360px;
  border-radius: 999px;
  height: 44px;
  font-weight: 600;
}

/* Category Deleted (success) Modal */
.category-deleted-modal .ant-modal-content {
  padding: 0;
}

.category-deleted-modal .ant-modal-close {
  top: 16px;
  right: 16px;
}

.category-deleted-close-icon {
  color: #ff4d4f !important;
  font-size: 18px;
}

.category-deleted-hero {
  position: relative;
  height: 160px;
  background: #fff5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.category-deleted-hero-shapes {
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 20% 50%, rgba(255, 182, 193, 0.4) 0%, transparent 50%),
    radial-gradient(circle at 80% 30%, rgba(255, 192, 203, 0.35) 0%, transparent 45%),
    radial-gradient(circle at 50% 80%, rgba(255, 182, 193, 0.3) 0%, transparent 40%);
  pointer-events: none;
}

.category-deleted-hero-icon {
  position: relative;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: 3px solid #ff4d4f;
  color: #ff4d4f;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  background: #fff;
}

.category-deleted-content {
  padding: 24px 28px 32px;
  text-align: center;
}

.category-deleted-title {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 8px;
}

.category-deleted-subtitle {
  font-size: 14px;
  color: #8c8c8c;
  line-height: 1.45;
  margin-bottom: 22px;
}

.category-deleted-btn {
  width: 70%;
  max-width: 360px;
  border-radius: 999px;
  height: 44px;
  font-weight: 600;
}

/* ========== Approved Vendors ========== */
.approved-vendors-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.approved-vendors-header {
  padding: 20px 24px 16px;
  border-bottom: 1px solid #f0f0f0;
}

.approved-vendors-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a1a;
}

.approved-vendors-count {
  font-weight: 500;
  color: #666;
  margin-left: 4px;
}

.approved-vendors-table .ant-table {
  font-size: 14px;
}

.approved-vendors-table .ant-table-thead>tr>th {
  background: #fafafa;
  font-weight: 600;
  color: #666;
  padding: 14px 16px;
}

.approved-vendors-table .ant-table-tbody>tr>td {
  padding: 16px;
  vertical-align: middle;
}

.approved-vendors-table .ant-table-tbody>tr:hover>td {
  background: #fafafa;
}

.approved-vendors-cell-vendor {
  display: flex;
  align-items: center;
  gap: 12px;
}

.approved-vendors-vendor-info {
  min-width: 0;
}

.approved-vendors-vendor-name {
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 2px;
}

.approved-vendors-vendor-mart {
  font-size: 13px;
  color: #666;
}

.approved-vendors-cell-email,
.approved-vendors-cell-phone {
  display: flex;
  align-items: center;
  gap: 8px;
}

.approved-vendors-icon-email {
  color: #fa8c16;
  font-size: 14px;
  flex-shrink: 0;
}

.approved-vendors-icon-phone,
.approved-vendors-icon-pin {
  color: #35b558;
  font-size: 14px;
  flex-shrink: 0;
}

.approved-vendors-cell-mart {
  display: flex;
  align-items: center;
  gap: 12px;
}

.approved-vendors-mart-logo,
.approved-vendors-store-logo {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.6);
  font-size: 18px;
}

.approved-vendors-mart-logo img,
.approved-vendors-store-logo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.approved-vendors-mart-info {
  min-width: 0;
}

.approved-vendors-mart-name {
  font-weight: 500;
  color: #1a1a1a;
  margin-bottom: 2px;
}

.approved-vendors-mart-address {
  font-size: 12px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 4px;
}

.approved-vendors-cell-store {
  display: flex;
  align-items: center;
  gap: 12px;
}

.approved-vendors-store-name {
  font-weight: 500;
  color: #1a1a1a;
}

.approved-vendors-table .ant-pagination-item-active {
  background: #35b558 !important;
  border-color: #35b558 !important;
}

.approved-vendors-table .ant-pagination-item-active a {
  color: #fff !important;
}

.approved-vendors-table .ant-pagination-item:hover a,
.approved-vendors-table .ant-pagination-next:hover .ant-pagination-item-link,
.approved-vendors-table .ant-pagination-prev:hover .ant-pagination-item-link {
  color: #35b558;
}

/* Approved Vendors empty state */
.approved-vendors-empty-wrap {
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
}

.approved-vendors-empty-wrap .ant-empty-description {
  margin-top: 24px;
}

.approved-vendors-empty-illustration {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 220px;
  box-sizing: border-box;
}

.approved-vendors-empty-phone {
  position: relative;
  width: 120px;
  height: 200px;
  border: 3px solid #35b558;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.approved-vendors-empty-bubble {
  position: absolute;
  inset: 12px;
  border-radius: 16px;
  background: linear-gradient(145deg, #52c41a 0%, #35b558 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.1);
}

.approved-vendors-empty-person-icon {
  font-size: 48px;
  color: #fff;
  position: relative;
  z-index: 1;
}

.approved-vendors-empty-sparkle {
  position: absolute;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.95);
}

.approved-vendors-empty-sparkle-1 {
  top: 12px;
  left: 14px;
}

.approved-vendors-empty-sparkle-2 {
  bottom: 14px;
  right: 12px;
}

.approved-vendors-empty-dot {
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #35b558;
  opacity: 0.6;
}

.approved-vendors-empty-dot-1 {
  top: 20px;
  right: 12px;
}

.approved-vendors-empty-dot-2 {
  bottom: 40px;
  left: 10px;
  background: #2196F3;
}

.approved-vendors-empty-dot-3 {
  bottom: 80px;
  right: 8px;
  width: 6px;
  height: 6px;
}

.approved-vendors-empty-star {
  position: absolute;
  font-size: 12px;
  color: #35b558;
  opacity: 0.8;
}

.approved-vendors-empty-star-1 {
  top: 40px;
  left: 8px;
}

.approved-vendors-empty-star-2 {
  bottom: 60px;
  right: 16px;
  color: #2196F3;
}

.approved-vendors-empty-text {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.approved-vendors-empty-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 8px;
}

.approved-vendors-empty-subtitle {
  font-size: 14px;
  color: #666;
  margin: 0;
}

.approved-vendors-notification-btn {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 10px;
  background: #fff7e6;
  color: #fa8c16;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 18px;
  transition: background 0.2s, color 0.2s;
}

.approved-vendors-notification-btn:hover {
  background: #ffd591;
  color: #d46b08;
}

/* Notification Modal (Approved Vendors) */
.notification-modal-close-icon {
  color: #ff4d4f !important;
  font-size: 18px;
}

.notification-modal .ant-modal-header {
  border-bottom: 1px solid #f0f0f0;
}

.notification-modal-body {
  padding: 8px 0 0;
}

.notification-modal-textarea {
  margin-bottom: 20px;
  border-radius: 8px;
}

.notification-modal-textarea.ant-input {
  font-size: 14px;
}

.notification-modal-send-btn {
  width: 100%;
  height: 48px;
  font-size: 16px;
  font-weight: 500;
  background: #35b558 !important;
  border-color: #35b558 !important;
}

.notification-modal-send-btn:hover {
  background: #2e9d4a !important;
  border-color: #2e9d4a !important;
}

/* ========== Cmslayout Dashboard (light sidebar + IYE branding) ========== */
.cmslayout-dashboard .cmslayout-sider-light {
  background: #fff !important;
  box-shadow: none;
}

.cmslayout-brand {
  height: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-bottom: none;
}

.cmslayout-brand-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #35b558;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
}

.cmslayout-brand-text {
  font-size: 20px;
  font-weight: 700;
  color: #35b558;
}

.cmslayout-brand-logo {
  height: 150px;
  width: auto;
  max-width: 100%;
  object-fit: contain;
  display: block;
  margin: 0 auto;
  transition: height 0.2s ease-in-out, width 0.2s ease-in-out;
}

.ant-layout-sider-collapsed .cmslayout-brand-logo {
  height: 40px;
  width: auto;
  max-width: 100%;
}

@media (max-width: 992px) {
  .cmslayout-brand-logo {
    height: 68px;
  }
}

@media (max-width: 576px) {
  .cmslayout-brand-logo {
    height: 40px;
  }
}

.cmslayout-menu-light.ant-menu-light {
  background: #fff !important;
  border-right: none !important;
  padding: 16px 0;
}

.cmslayout-menu-light .ant-menu-item {
  margin: 12px 24px 12px 16px;
  border-radius: 12px;
  height: 48px;
  line-height: 48px;
  color: #a0a0a0;
  font-weight: 500;
}

.cmslayout-menu-light .ant-menu-item a {
  color: inherit;
}

.cmslayout-menu-light .ant-menu-item:hover,
.cmslayout-menu-light .ant-menu-item:hover a {
  color: #35b558;
}

.cmslayout-menu-light .ant-menu-item-selected {
  background: #ebfaeb !important;
  color: #35b558 !important;
  font-weight: 600;
  position: relative;
  border-radius: 0 24px 24px 0;
  margin: 12px 24px 12px 0;
  padding-left: 28px !important;
}

.cmslayout-menu-light .ant-menu-item-selected::after {
  content: '';
  position: absolute;
  right: 0;
  top: 0;
  width: 6px;
  height: 100%;
  background: #35b558;
  border-radius: 0 24px 24px 0;
  transform: none;
}

.cmslayout-menu-light .ant-menu-item-selected a {
  color: #35b558 !important;
}

.cmslayout-menu-light .ant-menu-submenu-title {
  margin: 12px 24px 12px 16px !important;
  border-radius: 12px;
  height: 48px !important;
  line-height: 48px !important;
  color: #a0a0a0 !important;
  font-weight: 500;
}

.cmslayout-menu-light .ant-menu-submenu-title:hover {
  color: #35b558 !important;
}

.cmslayout-menu-light .ant-menu-submenu-selected>.ant-menu-submenu-title {
  color: #35b558 !important;
}

.cmslayout-menu-light .ant-menu-sub.ant-menu-inline {
  background: #fff !important;
}

.cmslayout-menu-light .ant-menu-sub.ant-menu-inline .ant-menu-item {
  height: auto;
  min-height: 42px;
  line-height: 1.25;
  margin-top: 6px;
  margin-bottom: 6px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.cmslayout-content-wrap {
  /* background: #f4f7f6; */
  padding: 0;
}

/* ========== Data-lite Rep Dashboard pages ========== */
.data-lite-page,
.data-lite-panel {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  padding: 24px;
}

.data-lite-stack {
  display: grid;
  gap: 16px;
  background: transparent;
  box-shadow: none;
  padding: 0;
}

.data-lite-section-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 18px;
}

.data-lite-section-title {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
}

.data-lite-section-description {
  font-size: 13px;
  color: #777;
  margin-top: 4px;
  max-width: 680px;
}

.data-lite-section-action {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.data-lite-table-wrap {
  width: 100%;
  overflow-x: auto;
}

.data-lite-table {
  width: 100%;
  min-width: 560px;
  border-collapse: collapse;
  color: #1f1f1f;
}

.data-lite-table th,
.data-lite-table td {
  border-bottom: 1px solid #eef1f0;
  padding: 14px 12px;
  text-align: left;
  vertical-align: middle;
  font-size: 14px;
}

.data-lite-table th {
  color: #6f7b76;
  font-weight: 700;
  background: #f8fbfa;
  white-space: nowrap;
}

.data-lite-table tr:last-child td {
  border-bottom: none;
}

.data-lite-number-cell {
  text-align: right !important;
  white-space: nowrap;
}

.progress-text-bar {
  display: inline-block;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
  color: #245d38;
  background: #f1faf3;
  border: 1px solid #d7f0dd;
  border-radius: 8px;
  padding: 6px 8px;
  white-space: nowrap;
}

.data-lite-empty {
  min-height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.vendor-action {
  display: inline-flex;
  align-items: center;
  min-height: 30px;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 700;
  background: #f4f7f6;
  color: #52615b;
  white-space: nowrap;
}

.vendor-action.warn-vendor {
  background: #fff6e0;
  color: #9a6400;
}

.vendor-action.consider-delisting {
  background: #fff0f0;
  color: #b63436;
}

.review-filter-group {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.review-filter-group .ant-btn-primary {
  background: #35b558;
  border-color: #35b558;
}

.review-list {
  display: grid;
  gap: 12px;
}

.review-card {
  border: 1px solid #eef1f0;
  border-radius: 12px;
  padding: 16px;
  background: #fff;
}

.review-card-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 14px;
}

.review-card-title {
  font-size: 15px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
}

.review-card-meta,
.review-card-order,
.review-card-full {
  font-size: 13px;
  color: #6f7b76;
}

.review-card-meta {
  margin-top: 4px;
}

.review-card-order {
  margin-top: 10px;
}

.review-card-full {
  color: #333;
  margin-top: 12px;
  line-height: 1.55;
}

.review-rating {
  flex: 0 0 auto;
  border-radius: 999px;
  padding: 4px 9px;
  background: #edf8ef;
  color: #247a3a;
  font-size: 12px;
  font-weight: 700;
}

.review-rating.is-flagged {
  background: #fff0f0;
  color: #b63436;
}

.review-view-more.ant-btn-link {
  padding: 0;
  height: auto;
  margin-top: 12px;
  color: #35b558;
  font-weight: 700;
}

@media (max-width: 767px) {

  .data-lite-page,
  .data-lite-panel {
    border-radius: 14px;
    padding: 16px;
  }

  .data-lite-section-header {
    gap: 12px;
  }

  .data-lite-section-action,
  .review-filter-group {
    width: 100%;
  }

  .review-filter-group .ant-btn {
    flex: 1 1 130px;
  }

  .data-lite-table {
    min-width: 0;
  }

  .data-lite-table thead {
    display: none;
  }

  .data-lite-table,
  .data-lite-table tbody,
  .data-lite-table tr,
  .data-lite-table td {
    display: block;
    width: 100%;
  }

  .data-lite-table tr {
    border: 1px solid #eef1f0;
    border-radius: 12px;
    padding: 10px 12px;
    margin-bottom: 10px;
  }

  .data-lite-table td {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    border-bottom: none;
    padding: 5px 0;
  }

  .data-lite-table td::before {
    content: attr(data-label);
    color: #6f7b76;
    font-weight: 700;
    flex: 0 0 38%;
  }

  .data-lite-number-cell {
    text-align: left !important;
  }

  .progress-text-bar {
    max-width: 100%;
    overflow-wrap: anywhere;
  }
}

/* ========== CMS top bar (global) ========== */
.cms-topbar.ant-layout-header {
  height: auto !important;
  line-height: initial !important;
  padding: 0 !important;
  background: #ffffff !important;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  position: sticky;
  top: 0;
  z-index: 20;
}

.cms-topbar-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 20px;
}

.cms-topbar-spacer {
  flex: 1 1;
}

.cms-logout-btn {
  background: #35b558 !important;
  border-color: #35b558 !important;
  border-radius: 10px !important;
  font-weight: 600;
}

.cms-logout-btn:hover {
  background: #2da24e !important;
  border-color: #2da24e !important;
}


/* TextField Styling */
.markets-search.ant-input-affix-wrapper {
  width: 420px;
  height: 50px;
  border-radius: 30px;
  border: none !important;
  box-shadow: none !important;
  background: #FFFFFF;
  padding: 0 20px;
  display: flex;
  align-items: center;
}

.markets-search.ant-input-affix-wrapper:hover,
.markets-search.ant-input-affix-wrapper:focus,
.markets-search.ant-input-affix-wrapper-focused {
  border: none !important;
  box-shadow: none !important;
  background: #FFFFFF;
}

.markets-search .ant-input {
  background: transparent;
  border: none;
  box-shadow: none;
  font-size: 16px;
}

.markets-search .ant-input::placeholder {
  color: #cfcfcf;
  font-size: 16px;
  font-weight: 400;
}

.markets-search .ant-input-prefix {
  margin-right: 18px;
  display: flex;
  align-items: center;
}

.markets-search-icon {
  font-size: 16px;
  color: #fff;
  background: #35c759;
  border-radius: 50%;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.approved-vendors-card {
  padding: 24px;
  overflow: hidden;
}

.approved-vendors-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  margin-bottom: 24px;
  padding: 4px 0 10px;
}

.approved-vendors-title {
  font-size: 18px;
  font-weight: 700;
  color: #1f1f1f;
  margin: 0;
  white-space: nowrap;
}

.approved-vendors-count {
  color: #666;
  font-weight: 500;
}

.approved-vendors-search-box {
  width: 360px;
  flex-shrink: 0;
}

.approved-vendors-search-input.ant-input-affix-wrapper {
  height: 58px;
  border: none !important;
  box-shadow: none !important;
  background: #f7f8fa !important;
  border-radius: 18px;
  padding: 0 18px;
}

.approved-vendors-search-input.ant-input-affix-wrapper:hover,
.approved-vendors-search-input.ant-input-affix-wrapper:focus,
.approved-vendors-search-input.ant-input-affix-wrapper-focused {
  border: none !important;
  box-shadow: none !important;
  background: #f7f8fa !important;
}

.approved-vendors-search-input .ant-input {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  font-size: 16px;
  color: #1f1f1f;
}

.approved-vendors-search-input .ant-input::placeholder {
  color: #b9b9b9;
}

.approved-vendors-search-input .ant-input-prefix {
  margin-right: 12px;
  display: flex;
  align-items: center;
}

.approved-vendors-search-icon {
  font-size: 18px;
  color: #fff;
  background: #35c759;
  border-radius: 50%;
  padding: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ==================================================== */
/* Sidebar Collapse Trigger Overrides */
/* ==================================================== */

.cmslayout-sider-light .ant-layout-sider-trigger {
  background: #ffffff !important;
  color: #8c8c8c !important;
  border-top: 1px solid #f0f0f0;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.02);
  transition: all 0.3s;
  z-index: 10;
}

.cmslayout-sider-light .ant-layout-sider-trigger:hover {
  background: #fafafa !important;
  color: #35c759 !important;
}

/* ========== Packages Management ========== */
.package-list-wrap {
  padding: 20px;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.package-list-wrap-empty {
  min-height: calc(100vh - 250px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.package-loading-state {
  min-height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.package-filter-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0;
}

.package-filter-group .ant-radio-button-wrapper {
  border-radius: 10px;
  margin-left: 6px;
  border-inline-start-width: 1px;
}

.package-filter-group .ant-radio-button-wrapper:first-child {
  margin-left: 0;
}

.package-filter-group .ant-radio-button-wrapper-checked {
  border-color: #35b558 !important;
  color: #35b558 !important;
}

.packages-card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(420px, 1fr));
  gap: 16px;
  width: 100%;
  align-items: start;
  justify-content: stretch;
}

.package-card {
  display: flex;
  gap: 16px;
  padding: 18px;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 14px;
  box-shadow: 0 8px 22px rgba(25, 38, 31, 0.06);
  min-width: 0;
  width: 100%;
  align-items: stretch;
}

.package-card-image {
  width: 118px;
  height: 118px;
  min-width: 118px;
  border-radius: 12px;
  overflow: hidden;
  background: #f7faf8;
  border: 1px solid #eef3ef;
}

.package-card-image-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.package-card-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    linear-gradient(135deg, rgba(53, 181, 88, 0.08), rgba(53, 181, 88, 0.02)),
    #f7faf8;
  color: #35b558;
}

.package-card-placeholder .anticon {
  font-size: 36px;
}

.package-card-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 12px;
}

.package-card-title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 4px;
}

.package-card-name {
  color: #1a1a1a;
  font-size: 18px;
  font-weight: 700;
}

.package-card-price {
  color: #35b558;
  font-size: 16px;
  font-weight: 700;
  text-transform: capitalize;
}

.package-card-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  color: #666;
  font-size: 12px;
  margin-top: 6px;
}

.package-card-meta span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.package-card-description {
  color: #666;
  display: -webkit-box;
  font-size: 13px;
  line-height: 1.45;
  margin-top: 8px;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.package-card-actions {
  justify-content: flex-start;
}

.package-form-modal .ant-modal-body {
  max-height: 76vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.package-input-number,
.package-input-number.ant-input-number {
  width: 100%;
  border-radius: 12px;
}

.package-status-switch.ant-switch-checked {
  background: #35b558;
}

.package-upload-box {
  width: 180px;
  height: 140px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #f0f0f0;
  background: #f6ffed;
  display: flex;
  align-items: center;
  justify-content: center;
}

.package-upload-box .ant-upload,
.package-upload-box .ant-upload-select {
  width: 100%;
  height: 100%;
  display: block;
}

.package-upload-placeholder {
  width: 100%;
  height: 100%;
  min-height: 138px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
  text-align: center;
}

.package-upload-box .add-mart-upload-preview {
  width: 100%;
  height: 100%;
}

.package-product-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
}

.package-product-option small {
  color: #8c8c8c;
  font-size: 11px;
  white-space: nowrap;
}

.package-select-state {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #8c8c8c;
}

.package-builder-stack,
.package-items-builder {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.package-benefit-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 40px;
  gap: 8px;
  align-items: center;
}

.package-item-row {
  display: grid;
  grid-template-columns:
    minmax(150px, 1fr) minmax(180px, 1.35fr) minmax(72px, 0.45fr) minmax(190px, 1.2fr) minmax(112px, auto) 40px;
  gap: 8px;
  align-items: center;
  padding: 10px;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  background: #fafafa;
  min-width: 0;
}

.package-item-row .ant-select,
.package-item-row .ant-input-number {
  min-width: 0;
}

.package-item-quantity,
.package-item-quantity.ant-input-number,
.package-item-unit {
  width: 100%;
}

.package-add-line-btn {
  height: 40px;
  border-radius: 10px;
  color: #35b558;
  border-color: #b7eb8f;
}

.package-add-line-btn:hover {
  color: #2da24e !important;
  border-color: #35b558 !important;
}

.package-modal-footer .ant-form-item-control-input-content {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  background: #fff;
}

.package-modal-footer .markets-add-btn {
  width: auto;
  min-width: 150px;
}

.package-detail-hero {
  display: flex;
  align-items: center;
  gap: 18px;
  margin-bottom: 18px;
}

.package-detail-image {
  width: 132px;
  height: 132px;
  border-radius: 14px;
  background: #f7faf8;
  border: 1px solid #eef3ef;
  overflow: hidden;
  flex-shrink: 0;
}

.package-detail-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.package-detail h2 {
  color: #1a1a1a;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 6px;
}

.package-detail-price {
  color: #35b558;
  font-size: 17px;
  font-weight: 700;
  margin-bottom: 8px;
  text-transform: capitalize;
}

.package-detail-section {
  margin-top: 18px;
}

.package-detail-section h3 {
  color: #1a1a1a;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 10px;
}

.package-detail-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.package-detail-list li {
  color: #4d4d4d;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.package-detail-list .anticon {
  color: #35b558;
  flex-shrink: 0;
}

.package-detail-category {
  padding: 12px;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  background: #fafafa;
  margin-bottom: 10px;
}

.package-detail-category-title {
  color: #1a1a1a;
  font-weight: 700;
  margin-bottom: 8px;
}

@media (max-width: 991px) {
  .packages-card-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .package-filter-group {
    justify-content: flex-start;
  }

  .package-item-row {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
}

@media (max-width: 576px) {

  .package-card,
  .package-detail-hero {
    flex-direction: column;
    align-items: flex-start;
  }

  .package-card-image {
    width: 100%;
    height: 160px;
  }

  .package-item-row {
    grid-template-columns: minmax(0, 1fr);
  }

  .package-modal-footer .ant-form-item-control-input-content {
    flex-direction: column-reverse;
  }

  .package-modal-footer .markets-add-btn {
    width: 100%;
  }
}

/* ========== Master Products ========== */
.master-product-info-banner {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  margin-bottom: 16px;
  border: 1px solid #d9f7be;
  border-radius: 12px;
  background: #f6ffed;
  color: #3f5f45;
  font-size: 13px;
  line-height: 1.45;
}

.master-product-info-banner .anticon {
  color: #35b558;
  margin-top: 3px;
}

.master-product-category-filter {
  width: 100%;
}

.master-product-header-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
}

.master-product-csv-input {
  display: none;
}

.master-product-list-wrap {
  padding: 0;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.master-product-list-wrap-empty {
  min-height: calc(100vh - 270px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.master-product-code {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  padding: 3px 8px;
  margin-bottom: 5px;
  border-radius: 999px;
  background: #f6ffed;
  color: #2e7d32;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.2px;
  word-break: break-word;
}

.master-product-code-input.ant-input {
  color: #2e7d32;
  font-weight: 700;
  background: #f6ffed;
  border-color: #d9f7be;
}

.master-products-table .ant-table {
  border-radius: 16px;
}

.master-products-table .ant-table-thead>tr>th {
  background: #f8fbf8;
  color: #374151;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.master-products-table .ant-table-tbody>tr>td {
  padding-top: 11px;
  padding-bottom: 11px;
  vertical-align: middle;
}

.master-product-table-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.master-product-csv-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}

.master-product-csv-summary .ant-statistic {
  padding: 12px 14px;
  border: 1px solid #eef3ef;
  border-radius: 12px;
  background: #f8fbf8;
}

.master-product-csv-errors {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

.master-product-csv-invalid-row>td {
  background: #fff7f7 !important;
}

@media (max-width: 991px) {
  .master-product-header-actions {
    justify-content: flex-start;
    width: 100%;
  }

  .master-product-status-filter {
    justify-content: flex-start;
  }
}

@media (max-width: 576px) {
  .master-product-csv-summary {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,sFAAsF;AACxF;;AAEA;EACE,2BAA2B;EAC3B,qFAAoF;AACtF;;AAEA;EACE,yBAAyB;EACzB,mFAAgF;AAClF;;AAEA;EACE,8BAA8B;EAC9B,mFAAqF;AACvF;;AAEA;EACE,6BAA6B;EAC7B,kFAAmF;AACrF;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;;AAGA;;;;EAIE,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;AACd;;AAEA;;;GAGG;AACH;EACE,uBAAuB;AACzB;;AAEA;;;;;;;;;;;;EAYE,SAAS;EACT,UAAU;AACZ;;;AAGA;EACE,SAAS;AACX;;;;;AAKA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;EAEE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;EACjB;AACF;;AAEA,mCAAmC;AACnC;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA,+BAA+B;AAC/B;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA,kDAAkD;AAClD;EACE,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,qDAAqD;AACrD;;EAEE,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,qDAAqD;EACrD,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;;EAEE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA,SAAS;AACT;EACE,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,yDAAyD;EACzD,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,8CAA8C;EAC9C,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,uBAAuB;EACvB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,8BAA8B;EAC9B,gCAAgC;EAChC,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;;EAEE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;EACrB;AACF;;;AAGA,WAAW;AACX;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,uDAAuD;AACzD;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,YAAY;IACZ,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,2BAA2B;;AAE3B,kCAAkC;AAClC;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA,4EAA4E;AAC5E;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,oEAAoE;EACpE,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,4BAA4B;AAC9B;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,2CAA2C;AAC3C;EACE,UAAU;EACV,YAAY;EACZ,qCAAqC;AACvC;;AAEA;iFACiF;AACjF;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,qDAAqD;AACrD;EACE,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,eAAe;EACf,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,6CAA6C;EAC7C,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,yCAAyC;EACzC,UAAU;EACV,WAAW;EACX,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA,uCAAuC;AACvC;EACE,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,SAAS;EACT,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,cAAc;AAChB;;AAEA,mBAAmB;AACnB,mCAAmC;AACnC;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA,4EAA4E;AAC5E;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,gDAAgD;AAChD;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,2CAA2C;AAC7C;;AAEA,qEAAqE;AACrE;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,0EAA0E;EAC1E,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,yDAAmO;AACrO;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,2CAA2C;AAC3C;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;EAC3B,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,SAAS;EACT,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,oCAAoC;AACpC;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;oFAEkF;EAClF,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,SAAS;EACT,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,6EAA6E;AAC7E;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,2DAA2D;AAC7D;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA,wDAAwD;AACxD;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gGAAgG;EAChG,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;;;EAGE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE;;IAEE,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;;;;IAIE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;AACF;;AAEA,+CAA+C;AAC/C;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;EACrB,8BAA8B;EAC9B,yCAAyC;EACzC,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;;AAGA,sBAAsB;AACtB;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;EAGE,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,2BAA2B;EAC3B,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;EAGE,uBAAuB;EACvB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,yDAAyD;AACzD,uCAAuC;AACvC,yDAAyD;;AAEzD;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,6BAA6B;EAC7B,2CAA2C;EAC3C,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,MAAM;AACR;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,YAAY;EACZ,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;WAES;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb;+GAC6G;EAC7G,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,oDAAoD;EACtD;AACF;;AAEA;;EAEE;;IAEE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,2BAA2B;IAC3B,WAAW;EACb;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["@font-face {\n  font-family: \"Cairo-Regular\";\n  src: local(\"CairoRrgular\"), url(\"./assets/fonts/Cairo-Regular.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Cairo-Medium\";\n  src: local(\"CairoMedium\"), url(\"./assets/fonts/Cairo-Medium.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Cairo-Bold\";\n  src: local(\"CairoBold\"), url(\"./assets/fonts/Cairo-Bold.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Cairo-ExtraBold\";\n  src: local(\"ExtraBold\"), url(\"./assets/fonts/Cairo-ExtraBold.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Cairo-SemiBold\";\n  src: local(\"SemiBold\"), url(\"./assets/fonts/Cairo-SemiBold.ttf\") format(\"truetype\");\n}\n\n:root {\n  --primarymehroon: #B63436;\n  --lightdark: #333333;\n  --harddark: #1A1A1A;\n  --white: #fff;\n  --black: #000;\n  --offwhite: #D9D9D9;\n}\n\n\na,\np,\nli,\nspan {\n  font-family: system-ui;\n  text-decoration: none;\n  padding: 0px;\n}\n\n/* :where(.css-dev-only-do-not-override-zl9ks2)[class^=\"ant-layout\"],\n:where(.css-dev-only-do-not-override-zl9ks2)[class*=\" ant-layout\"] {\n  font-size: 0;\n} */\n.ant-layout {\n  background: transparent;\n}\n\na,\np,\nli,\nspan,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nstrong,\nb {\n  margin: 0;\n  padding: 0;\n}\n\n\n.row {\n  margin: 0;\n}\n\n\n\n\n.card-setsider .imgset img {\n  border-radius: 4px;\n  box-shadow: 0px 0px 14px -4px #bcb320;\n  margin: 4px 0px;\n}\n\n.card-setsider:hover .imgset img {\n  border-radius: 22px;\n  transform: 37%;\n  transform: scale(1.04);\n  transition: 1s;\n}\n\n.card-setsider .imgset {\n  border-radius: 10px;\n}\n\n.adminpanelhdr {\n  background: #133a46 !important;\n}\n\n.ant-menu-dark,\n.ant-menu-dark>.ant-menu {\n  background: transparent;\n}\n\n.ant-layout .ant-layout-sider {\n  background: #f0fbff;\n}\n\n.ant-menu-dark.ant-menu-inline .ant-menu-sub.ant-menu-inline,\n.ant-menu-dark>.ant-menu.ant-menu-inline .ant-menu-sub.ant-menu-inline {\n  background: #133a46;\n}\n\n.ant-menu-dark .ant-menu-item-selected,\n.ant-menu-dark>.ant-menu .ant-menu-item-selected {\n  background-color: #0f323d;\n}\n\n.ant-layout .ant-layout-sider-trigger {\n  background: #133a46;\n}\n\n.ant-layout-header {\n  height: auto !important;\n}\n\n.row-breadcrumb.row {\n  background: #f8f8f8;\n}\n\n.card.graphscards {\n  background: #011930;\n}\n\n.ant-layout .ant-layout-sider .ant-menu-dark .ant-menu-item a,\n.ant-layout .ant-layout-sider .ant-menu-dark>.ant-menu .ant-menu-item a,\n.ant-layout .ant-layout-sider .ant-menu-dark .ant-menu-item a:hover,\n.ant-layout .ant-layout-sider .ant-menu-dark>.ant-menu .ant-menu-item a:hover {\n  color: #858585;\n}\n\n.ant-layout .ant-layout-sider-trigger {\n  background: #f0fbff;\n}\n\n.ant-layout .ant-layout-sider-trigger {\n  background: #96d08c;\n}\n\n.ant-layout-sider-children .ant-menu-dark .ant-menu-item,\n.ant-layout-sider-children .ant-menu-dark>.ant-menu .ant-menu-item,\n.ant-layout-sider-children .ant-menu-dark .ant-menu-submenu-title,\n.ant-layout-sider-children .ant-menu-dark>.ant-menu .ant-menu-submenu-title {\n  color: #858585 !important;\n}\n\n.card.graphscards div {\n  line-height: initial;\n}\n\n.card.graphscards {\n  background: #011930;\n  padding: 8px;\n  border-radius: 4px;\n  color: #b8b8b8;\n}\n\n.card.graphscards {\n  background: #011930;\n  padding: 8px;\n  border-radius: 4px;\n  color: #b8b8b8;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.ant-layout-header {\n  height: auto;\n  line-height: initial;\n}\n\n.ant-layout-sider .ant-menu-dark .ant-menu-item-selected,\n.ant-layout-sider .ant-menu-dark>.ant-menu .ant-menu-item-selected {\n  background-color: #34C759;\n  color: #fff !important;\n}\n\n.ant-layout-sider .ant-menu-dark .ant-menu-item-selected a {\n  color: #fff !important;\n}\n\n.ant-menu-dark.ant-menu-inline .ant-menu-sub.ant-menu-inline,\n.ant-menu-dark>.ant-menu.ant-menu-inline .ant-menu-sub.ant-menu-inline {\n  background: #e5f8ff;\n}\n\n.login-bg {\n  min-height: 100vh;\n  background: #f3f4f6;\n  display: flex;\n  align-items: center;\n}\n\n.login-card {\n  min-height: 640px;\n  background: #fff;\n  border-radius: 28px;\n  display: flex;\n  overflow: hidden;\n  box-shadow: 0 16px 60px rgba(0, 0, 0, 0.12);\n}\n\n.login-left {\n  width: 50%;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 48px;\n}\n\n.login-form-wrap {\n  width: 100%;\n  max-width: 420px;\n}\n\n.login-title {\n  font-size: 28px;\n  font-weight: 700;\n  color: #1a1a1a;\n}\n\n.login-subtitle {\n  font-size: 14px;\n  color: #8c8c8c;\n}\n\n.login-row-between {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin: 10px 0 18px;\n}\n\n.login-remember {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #666;\n  user-select: none;\n}\n\n.login-remember input {\n  width: 14px;\n  height: 14px;\n  accent-color: #35b558;\n}\n\n.login-right {\n  width: 50%;\n  background: #eaf7ef;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  padding: 40px 24px;\n}\n\n.login-illustration-circle {\n  width: min(380px, 78%);\n  aspect-ratio: 1;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.login-illustration {\n  width: 210px;\n  max-width: 80%;\n  height: auto;\n  object-fit: contain;\n  display: block;\n}\n\n.login-illustration-caption {\n  margin-top: 22px;\n  font-size: 16px;\n  font-weight: 700;\n  color: #35b558;\n}\n\n.login-btn {\n  background: #35b558;\n  color: #fff;\n  border: none;\n  font-weight: 600;\n  height: 54px;\n}\n\n.login-btn:hover {\n  background: #2da24e !important;\n  color: #fff !important;\n}\n\n.eye-icon {\n  position: absolute;\n  right: 18px;\n  top: 18px;\n  color: #999;\n}\n\n/* Forgot Password Modal */\n.forgot-password-modal .ant-modal-content {\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n.forgot-password-modal .ant-modal-close {\n  top: 16px;\n  right: 16px;\n}\n\n.forgot-password-close-icon {\n  color: #ff4d4f !important;\n  font-size: 18px;\n}\n\n.forgot-password-content {\n  padding: 18px 22px 22px;\n}\n\n.forgot-password-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #1a1a1a;\n  margin-bottom: 10px;\n}\n\n.forgot-password-subtitle {\n  font-size: 13px;\n  color: #8c8c8c;\n  line-height: 1.45;\n  margin-bottom: 16px;\n}\n\n.forgot-password-btn {\n  width: 100%;\n  height: 48px;\n  border-radius: 999px;\n  background: #35b558 !important;\n  border-color: #35b558 !important;\n  font-weight: 600;\n  margin-top: 6px;\n}\n\n.forgot-password-btn:hover {\n  background: #2da24e !important;\n  border-color: #2da24e !important;\n}\n\n/* Verify OTP Modal */\n.verify-otp-modal .ant-modal-content {\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n.verify-otp-modal .ant-modal-close {\n  top: 16px;\n  right: 16px;\n}\n\n.verify-otp-close-icon {\n  color: #ff4d4f !important;\n  font-size: 18px;\n}\n\n.verify-otp-content {\n  padding: 18px 22px 22px;\n  text-align: left;\n}\n\n.verify-otp-title {\n  font-size: 20px;\n  font-weight: 800;\n  color: #1a1a1a;\n  margin-bottom: 10px;\n}\n\n.verify-otp-subtitle {\n  font-size: 14px;\n  color: #8c8c8c;\n  line-height: 1.45;\n  margin-bottom: 14px;\n}\n\n.verify-otp-email {\n  color: #666;\n  font-weight: 600;\n}\n\n.verify-otp-timer {\n  text-align: center;\n  color: #ff4d4f;\n  font-weight: 700;\n  margin: 6px 0 14px;\n}\n\n.verify-otp-inputs {\n  display: flex;\n  justify-content: center;\n  gap: 14px;\n  margin-bottom: 14px;\n}\n\n.verify-otp-box {\n  width: 56px;\n  height: 56px;\n  border-radius: 12px;\n  border: 2px solid #f0f0f0;\n  background: #f7f7f7;\n  text-align: center;\n  font-size: 20px;\n  font-weight: 700;\n  outline: none;\n}\n\n.verify-otp-box:focus {\n  border-color: #35b558;\n  background: #fff;\n  box-shadow: 0 0 0 3px rgba(53, 181, 88, 0.15);\n}\n\n.verify-otp-box--filled {\n  background: #35b558;\n  border-color: #35b558;\n  color: #fff;\n}\n\n.verify-otp-resend {\n  width: 100%;\n  text-align: center;\n  background: transparent;\n  border: none;\n  color: #35b558;\n  font-weight: 600;\n  margin: 4px 0 18px;\n  cursor: pointer;\n}\n\n.verify-otp-resend:disabled {\n  color: #bfbfbf;\n  cursor: not-allowed;\n}\n\n.verify-otp-verify-btn {\n  width: 100%;\n  height: 54px;\n  border-radius: 999px;\n  background: #35b558 !important;\n  border-color: #35b558 !important;\n  font-weight: 700;\n  font-size: 16px;\n}\n\n.verify-otp-verify-btn:hover {\n  background: #2da24e !important;\n  border-color: #2da24e !important;\n}\n\n@media (max-width: 520px) {\n  .verify-otp-inputs {\n    gap: 10px;\n  }\n\n  .verify-otp-box {\n    width: 44px;\n    height: 44px;\n    border-radius: 10px;\n    font-size: 18px;\n  }\n}\n\n/* Password Changed Success Modal */\n.password-changed-modal .ant-modal-content {\n  padding: 0;\n}\n\n.password-changed-modal .ant-modal-close {\n  top: 16px;\n  right: 16px;\n}\n\n.password-changed-close-icon {\n  color: #ff4d4f !important;\n  font-size: 18px;\n}\n\n.password-changed-hero {\n  position: relative;\n  height: 170px;\n  background: #eefcf2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.password-changed-hero-wave {\n  position: absolute;\n  left: -10%;\n  right: -10%;\n  bottom: -44px;\n  height: 120px;\n  background: #fff;\n  border-top-left-radius: 60% 80%;\n  border-top-right-radius: 60% 80%;\n}\n\n.password-changed-hero-icon {\n  width: 76px;\n  height: 76px;\n  border-radius: 50%;\n  border: 3px solid #35b558;\n  color: #35b558;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 34px;\n  background: rgba(255, 255, 255, 0.9);\n  position: relative;\n}\n\n.password-changed-content {\n  padding: 24px 28px 32px;\n  text-align: center;\n}\n\n.password-changed-title {\n  font-size: 18px;\n  font-weight: 800;\n  color: #1a1a1a;\n  margin-bottom: 8px;\n}\n\n.password-changed-subtitle {\n  font-size: 14px;\n  color: #8c8c8c;\n  line-height: 1.45;\n  margin-bottom: 22px;\n}\n\n.password-changed-btn {\n  height: 48px;\n  border-radius: 12px;\n  background: #35b558 !important;\n  border-color: #35b558 !important;\n  font-weight: 700;\n  padding: 0 22px;\n}\n\n.password-changed-btn:hover {\n  background: #2da24e !important;\n  border-color: #2da24e !important;\n}\n\n.divider {\n  text-align: center;\n  margin: 25px 0;\n  color: #888;\n  font-size: 12px;\n}\n\n.social-row {\n  display: flex;\n  gap: 12px;\n}\n\n.social-btn {\n  width: 100%;\n  border-radius: 14px;\n  padding: 10px;\n  font-size: 14px;\n}\n\n@media (max-width: 992px) {\n  .login-card {\n    flex-direction: column;\n  }\n\n  .login-left,\n  .login-right {\n    width: 100%;\n  }\n\n  .login-right {\n    min-height: 360px;\n  }\n\n  .login-illustration {\n    width: 180px;\n  }\n}\n\n@media (max-width: 576px) {\n  .login-illustration {\n    width: 140px;\n  }\n}\n\n/* Remove antd default border */\n.custom-iy-input .ant-input,\n.custom-iy-input .ant-input-password {\n  border: none !important;\n  box-shadow: none !important;\n  height: 20px;\n}\n\n/* Shadow wrapper */\n.input-shadow {\n  background: #fff;\n  border-radius: 50px;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);\n}\n\n/* Remove double border between select and input */\n.country-code {\n  border: none !important;\n  background: transparent !important;\n  max-width: 90px;\n}\n\n.input-shadow .ant-form-item {\n  margin-bottom: 0 !important;\n}\n\n/* Compact input with shadow - fixes password field */\n.compact-shadow-input .ant-input,\n.compact-shadow-input .ant-input-password {\n  border: 1px solid #f5f5f5 !important;\n  /* remove default border */\n  box-shadow: none !important;\n  /* remove default ant shadow */\n  height: 50px;\n  /* smaller height */\n  padding: 10px 15px !important;\n  /* reduce padding */\n  border-radius: 18px;\n  /* slightly rounded */\n  font-size: 14px;\n  background: #fff;\n  /* white background */\n}\n\n/* Shadow wrapper */\n.compact-shadow-input .input-shadow {\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08) !important;\n  /* subtle shadow */\n  border-radius: 18px;\n}\n\n/* Fix Input.Password wrapper */\n.compact-shadow-input .ant-input-affix-wrapper {\n  height: 36px !important;\n  /* same height for wrapper */\n  padding: 0 15px !important;\n  display: flex;\n  align-items: center;\n  border-radius: 18px;\n}\n\n/* Fix prefix/suffix icons */\n.compact-shadow-input .ant-input-prefix,\n.compact-shadow-input .ant-input-suffix {\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n}\n\n/* Add subtle shadow */\n.compact-shadow-input .input-shadow {\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);\n  border-radius: 18px;\n}\n\n.loginlink {\n  text-decoration: none;\n  color: #000;\n}\n\n.loginlink:hover {\n  color: #2da24e;\n}\n\n/* Wrapper */\n.product-card-wrapper {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n/* Card */\n.product-card {\n  width: 100%;\n  max-width: 360px;\n  border-radius: 28px !important;\n  box-shadow: 0 14px 40px rgba(15, 23, 42, 0.08) !important;\n  background: #ffffff;\n}\n\n/* Image */\n.product-image-wrapper {\n  position: relative;\n  border-radius: 26px;\n  overflow: hidden;\n  background: #f3f4f6;\n  aspect-ratio: 4 / 3;\n}\n\n.product-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n/* Rating pill */\n.product-rating {\n  position: absolute;\n  right: 14px;\n  bottom: 14px;\n  background: #ffffff;\n  border-radius: 14px;\n  padding: 6px 10px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);\n  font-weight: 600;\n  font-size: 13px;\n}\n\n.product-star {\n  color: #f5b301;\n  font-size: 14px;\n}\n\n/* Content */\n.product-content {\n  text-align: center;\n  padding-top: 14px;\n}\n\n.product-title {\n  margin: 8px 0 4px !important;\n  font-weight: 500 !important;\n  color: #1f2a44 !important;\n}\n\n/* Price */\n.product-price-row {\n  margin-bottom: 12px;\n}\n\n.product-currency {\n  color: #ef4444;\n  font-weight: 600;\n  font-size: 18px;\n}\n\n.product-price {\n  color: #0f172a;\n  font-weight: 700;\n  font-size: 26px;\n}\n\n.product-unit {\n  color: #94a3b8;\n  font-size: 14px;\n}\n\n/* Vendor */\n.product-vendor-row {\n  justify-content: center;\n  width: 100%;\n  margin-bottom: 18px;\n}\n\n.product-vendor-avatar {\n  background: #fdecec !important;\n  color: #ef4444 !important;\n  font-weight: 700;\n}\n\n.product-vendor-name {\n  color: #9ca3af;\n  font-size: 14px;\n}\n\n/* Button */\n.product-add-btn {\n  height: 52px !important;\n  border-radius: 999px !important;\n  background: #22c55e !important;\n  border-color: #22c55e !important;\n  font-weight: 600 !important;\n  box-shadow: 0 12px 22px rgba(34, 197, 94, 0.25);\n}\n\n.product-add-btn:hover,\n.product-add-btn:focus {\n  background: #16a34a !important;\n  border-color: #16a34a !important;\n}\n\n/* Responsive tweaks */\n@media (max-width: 480px) {\n  .product-card {\n    max-width: 100%;\n    border-radius: 24px !important;\n  }\n\n  .product-image-wrapper {\n    border-radius: 22px;\n  }\n}\n\n\n/* Header */\n.iye-header {\n  width: 100%;\n  background: #2fbf55;\n}\n\n.iye-header__container {\n  height: 85px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  padding: 0 28px;\n}\n\n/* Brand */\n.iye-brand {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  min-width: 180px;\n}\n\n.iye-brand__img {\n  height: 48px;\n  width: auto;\n  max-width: 140px;\n  object-fit: contain;\n  display: block;\n}\n\n.iye-brand__text {\n  font-weight: 800;\n  letter-spacing: 1px;\n  font-size: 56px;\n  line-height: 1;\n  color: #ffffff;\n}\n\n.iye-brand__mark {\n  width: 66px;\n  height: 66px;\n  display: grid;\n  place-items: center;\n}\n\n/* Bag icon */\n.iye-bag {\n  position: relative;\n  width: 44px;\n  height: 44px;\n}\n\n.iye-bag__handle {\n  position: absolute;\n  top: 4px;\n  left: 10px;\n  width: 24px;\n  height: 16px;\n  border: 4px solid #ffffff;\n  border-bottom: 0;\n  border-radius: 16px 16px 0 0;\n  opacity: 0.95;\n}\n\n.iye-bag__body {\n  position: absolute;\n  top: 16px;\n  left: 8px;\n  width: 28px;\n  height: 26px;\n  background: #ffffff;\n  border-radius: 10px;\n}\n\n.iye-bag__leaves {\n  position: absolute;\n  top: -2px;\n  left: -2px;\n  width: 52px;\n  height: 18px;\n  display: flex;\n  gap: 4px;\n  align-items: flex-end;\n}\n\n.iye-leaf {\n  width: 10px;\n  height: 14px;\n  border-radius: 12px 12px 12px 0;\n  transform: rotate(-20deg);\n}\n\n.iye-leaf--1 {\n  background: #ff3b3b;\n}\n\n.iye-leaf--2 {\n  background: #ffa800;\n  transform: rotate(5deg);\n}\n\n.iye-leaf--3 {\n  background: #ffd400;\n  transform: rotate(25deg);\n}\n\n/* Nav */\n.iye-nav {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 56px;\n  flex: 1;\n}\n\n.iye-nav__link {\n  background: transparent;\n  border: 0;\n  color: #ffffff;\n  font-weight: 700;\n  font-size: 16px;\n  cursor: pointer;\n  padding: 10px 8px;\n  border-radius: 14px;\n  transition: background 160ms ease, transform 160ms ease;\n}\n\n.iye-nav__link:hover {\n  background: rgba(255, 255, 255, 0.1);\n  transform: translateY(-1px);\n}\n\n/* Actions */\n.iye-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 16px;\n  min-width: 520px;\n}\n\n.iye-pill {\n  appearance: none;\n  border: 2px solid rgba(255, 255, 255, 0.8);\n  background: rgba(255, 255, 255, 0.08);\n  color: #ffffff;\n  border-radius: 8px;\n  padding: 12px 10px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  transition: background 160ms ease, transform 160ms ease;\n}\n\n.iye-pill:hover {\n  background: rgba(255, 255, 255, 0.14);\n  transform: translateY(-1px);\n}\n\n.iye-pill__caret {\n  font-size: 14px;\n  opacity: 0.95;\n}\n\n.iye-pill__flag {\n  width: 34px;\n  height: 34px;\n  display: grid;\n  place-items: center;\n  background: rgba(255, 255, 255, 0.18);\n  border-radius: 999px;\n  font-size: 18px;\n}\n\n.iye-pill__currency {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  line-height: 1.1;\n}\n\n.iye-pill__currencyCode {\n  font-weight: 800;\n  font-size: 18px;\n}\n\n.iye-pill__rate {\n  font-weight: 700;\n  font-size: 14px;\n  opacity: 0.95;\n}\n\n.iye-pill__icon {\n  font-size: 22px;\n}\n\n.iye-pill__cartTotal {\n  font-weight: 800;\n  font-size: 18px;\n}\n\n.iye-pill__langIcon {\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.18);\n  font-weight: 800;\n  font-size: 14px;\n}\n\n.iye-pill__langText {\n  font-weight: 800;\n  font-size: 18px;\n}\n\n/* Hamburger */\n.iye-hamburger {\n  width: 62px;\n  height: 62px;\n  border-radius: 999px;\n  border: 0;\n  background: #ffffff;\n  color: #111111;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n  transition: transform 160ms ease;\n}\n\n.iye-hamburger:hover {\n  transform: translateY(-1px);\n}\n\n/* Responsive */\n@media (max-width: 1200px) {\n  .iye-header__container {\n    height: 96px;\n    padding: 0 18px;\n  }\n\n  .iye-brand__text {\n    font-size: 46px;\n  }\n\n  .iye-nav__link {\n    font-size: 22px;\n  }\n\n  .iye-actions {\n    min-width: 420px;\n  }\n}\n\n@media (max-width: 992px) {\n  .iye-nav {\n    display: none;\n  }\n\n  .iye-actions {\n    min-width: unset;\n    gap: 12px;\n  }\n\n  .iye-pill {\n    padding: 10px 12px;\n    border-radius: 16px;\n  }\n\n  .iye-pill__langText {\n    display: none;\n  }\n}\n\n@media (max-width: 640px) {\n  .iye-header__container {\n    height: 86px;\n    gap: 12px;\n    padding: 0 12px;\n  }\n\n  .iye-brand {\n    min-width: unset;\n    gap: 12px;\n  }\n\n  .iye-brand__text {\n    font-size: 38px;\n  }\n\n  .iye-pill--currency .iye-pill__rate {\n    display: none;\n  }\n\n  .iye-pill__flag {\n    width: 30px;\n    height: 30px;\n  }\n\n  .iye-hamburger {\n    width: 54px;\n    height: 54px;\n  }\n}\n\n/* global.css (plain CSS) */\n\n/* Wrapper matches dark bar look */\n.pticker {\n  width: 100%;\n  background: #000000;\n  padding: 10px 0;\n}\n\n/* container fluid already gives width; keep padding similar to screenshot */\n.pticker__container {\n  padding-left: 18px;\n  padding-right: 18px;\n}\n\n.pticker__viewport {\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n}\n\n/* Track: continuous movement */\n.pticker__track {\n  display: flex;\n  align-items: center;\n  width: max-content;\n  animation: pticker-marquee var(--pticker-speed, 28s) linear infinite;\n  will-change: transform;\n}\n\n/* Pause on hover (optional) */\n.pticker--pause .pticker__viewport:hover .pticker__track {\n  animation-play-state: paused;\n}\n\n/* Each item */\n.pticker__item {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  padding: 4px 18px;\n  white-space: nowrap;\n}\n\n.pticker__text {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 140px;\n}\n\n.pticker__title {\n  color: rgba(255, 255, 255, 0.92);\n  font-size: 18px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n}\n\n.pticker__meta {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.pticker__price {\n  color: rgba(255, 255, 255, 0.75);\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.pticker__change {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n/* colored arrow badge */\n.pticker__badge {\n  width: 24px;\n  height: 24px;\n  border-radius: 999px;\n  display: inline-grid;\n  place-items: center;\n  font-size: 12px;\n}\n\n.pticker__change.is-up {\n  color: #34d399;\n  /* green-ish */\n}\n\n.pticker__change.is-up .pticker__badge {\n  background: #059669;\n  /* darker green */\n  color: #ffffff;\n}\n\n.pticker__change.is-down {\n  color: #fb7185;\n  /* red-ish */\n}\n\n.pticker__change.is-down .pticker__badge {\n  background: #e11d48;\n  /* darker red */\n  color: #ffffff;\n}\n\n.pticker__changeText {\n  opacity: 0.95;\n}\n\n/* vertical separator like the screenshot */\n.pticker__sep {\n  width: 1px;\n  height: 38px;\n  background: rgba(255, 255, 255, 0.18);\n}\n\n/* seamless marquee:\n   Because we duplicate items, moving half the track width gives a perfect loop */\n@keyframes pticker-marquee {\n  0% {\n    transform: translateX(0);\n  }\n\n  100% {\n    transform: translateX(-50%);\n  }\n}\n\n/* Accessibility: screen reader only block */\n.pticker__sr {\n  position: absolute;\n  left: -9999px;\n  top: auto;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n}\n\n/* Responsive tweaks */\n@media (max-width: 992px) {\n  .pticker__title {\n    font-size: 16px;\n  }\n\n  .pticker__price,\n  .pticker__change {\n    font-size: 13px;\n  }\n\n  .pticker__item {\n    padding: 4px 14px;\n    gap: 14px;\n  }\n\n  .pticker__sep {\n    height: 34px;\n  }\n}\n\n@media (max-width: 576px) {\n  .pticker__container {\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n\n  .pticker__title {\n    font-size: 15px;\n  }\n\n  .pticker__text {\n    min-width: 120px;\n  }\n\n  .pticker__badge {\n    width: 22px;\n    height: 22px;\n  }\n}\n\n/* ========== Dashboard (Main Dashboard) ========== */\n.dashboard-wrap {\n  background: #f4f7f6;\n  min-height: 100%;\n  border-top-left-radius: 20px;\n}\n\n.dashboard-top-bar {\n  background: #fff;\n  box-shadow: none;\n  padding: 24px 0;\n  margin-bottom: 12px;\n}\n\n.dashboard-top-bar-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  max-width: 100%;\n  padding: 0 32px;\n  margin: 0;\n}\n\n.dashboard-top-bar-left {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.dashboard-top-bar-right {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  flex-wrap: nowrap;\n  flex-direction: row;\n}\n\n.dashboard-header {\n  padding: 0;\n}\n\n.dashboard-welcome {\n  font-size: 13px;\n  color: #888;\n  font-weight: 500;\n  margin-bottom: 4px !important;\n}\n\n.dashboard-title {\n  font-size: 22px;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.dashboard-header-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.dashboard-search-input {\n  background: #f8f9fa;\n  border-radius: 12px;\n  padding: 8px 16px;\n  width: 280px;\n}\n\n.dashboard-search-input input {\n  background: transparent;\n}\n\n.dashboard-avatar {\n  background: #d9d9d9;\n  color: #555;\n  cursor: pointer;\n}\n\n/* KPI cards */\n.dashboard-kpi-card {\n  border-radius: 20px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02);\n  background: #fff;\n  padding: 0;\n  height: 110px;\n}\n\n.dashboard-kpi-card .ant-card-body {\n  padding: 24px;\n}\n\n.dashboard-kpi-row {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.dashboard-kpi-icon-wrap {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 22px;\n  flex: 0 0 auto;\n}\n\n.dashboard-kpi-text {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.dashboard-kpi-value {\n  font-size: 20px;\n  font-weight: 700;\n  color: #1a1a1a;\n  line-height: 1.2;\n}\n\n.dashboard-kpi-label {\n  font-size: 13px;\n  color: #888;\n  font-weight: 500;\n  margin-top: 4px;\n}\n\n.dashboard-kpi-meta {\n  color: #35b558;\n  font-size: 12px;\n  font-weight: 600;\n  margin-top: 6px;\n}\n\n.dashboard-summary-error {\n  border-radius: 10px;\n}\n\n/* Chart card */\n.dashboard-chart-card {\n  border-radius: 24px;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.02);\n  background: #fff;\n  margin-top: 8px;\n}\n\n.dashboard-chart-card .ant-card-body {\n  padding: 32px;\n}\n\n.dashboard-chart-header {\n  margin-bottom: 24px;\n}\n\n.dashboard-chart-title-wrap {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.dashboard-chart-title {\n  font-weight: 500;\n  font-size: 18px;\n  color: #92a3c2;\n}\n\n.dashboard-chart-title-icon-btn {\n  background: #35b558;\n  width: 26px;\n  height: 26px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.dashboard-chart-big-value {\n  font-size: 32px;\n  font-weight: 700;\n  color: #1d253b;\n  line-height: 1;\n}\n\n.dashboard-chart-market-name {\n  color: #92a3c2;\n  font-size: 13px;\n  font-weight: 500;\n  margin-top: 8px;\n}\n\n.dashboard-chart-year-btn {\n  border-radius: 10px;\n  font-size: 14px;\n  color: #555;\n  border: 1px solid #eaeaea;\n  padding: 6px 16px;\n  height: 40px;\n  font-weight: 500;\n}\n\n.dashboard-chart-inner {\n  width: 100%;\n  min-height: 320px;\n  position: relative;\n}\n\n.dashboard-chart-state {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  min-height: 320px;\n}\n\n.dashboard-chart-error {\n  align-items: center;\n  color: #d4380d;\n  display: flex;\n  flex-direction: column;\n  font-size: 14px;\n  font-weight: 500;\n  gap: 12px;\n}\n\n.dashboard-chart-empty-note {\n  color: #92a3c2;\n  font-size: 13px;\n  font-weight: 500;\n  margin-bottom: 8px;\n  text-align: center;\n}\n\n.dashboard-chart-tooltip {\n  background: #00c2e0;\n  color: #fff;\n  padding: 8px 16px;\n  border-radius: 8px;\n  box-shadow: 0 4px 16px rgba(0, 194, 224, 0.3);\n  font-weight: 600;\n  font-size: 14px;\n  position: relative;\n}\n\n.dashboard-chart-tooltip::after {\n  content: '';\n  position: absolute;\n  bottom: -4px;\n  left: 50%;\n  transform: translateX(-50%) rotate(45deg);\n  width: 8px;\n  height: 8px;\n  background: #00c2e0;\n}\n\n/* ========== Markets module ========== */\n.markets-section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  gap: 16px;\n  padding: 0;\n}\n\n.markets-heading {\n  font-size: 18px;\n  font-weight: 700;\n  color: #1a1a1a;\n  margin: 0;\n}\n\n.markets-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.markets-search {\n  width: 200px;\n  min-width: 160px;\n  border-radius: 999px;\n}\n\n.markets-search .ant-input-affix-wrapper {\n  border-radius: 999px;\n}\n\n.markets-search-icon {\n  color: #35b558;\n}\n\n.markets-add-btn {\n  background: #35b558;\n  border-color: #35b558;\n  border-radius: 10px;\n  height: 45px;\n  font-weight: 600;\n}\n\n.markets-add-btn:hover {\n  background: #2da24e !important;\n  border-color: #2da24e !important;\n  color: #fff !important;\n}\n\n/* Portal-wide slightly round buttons */\n.adminpanel-layout .ant-btn {\n  border-radius: 10px;\n}\n\n/* Portal-wide round inputs in modals */\n.input-round.ant-input,\n.input-round .ant-input {\n  border-radius: 12px;\n}\n\n.textarea-round.ant-input {\n  border-radius: 12px;\n}\n\n.markets-search-full {\n  width: 100%;\n  max-width: 100%;\n}\n\n.markets-search-full .ant-input-affix-wrapper {\n  width: 100%;\n}\n\n.markets-empty-wrap {\n  padding: 48px 24px;\n  background: #fff;\n  border-radius: 20px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);\n  min-height: calc(100vh - 220px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.markets-empty-wrap:has(.markets-card-grid) {\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n\n/* Markets list grid */\n.markets-card-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n  width: 100%;\n}\n\n.market-card {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 16px;\n  background: #fff;\n  border: 1px solid #f0f0f0;\n  border-radius: 12px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);\n  min-width: 0;\n}\n\n.market-card-logo {\n  width: 56px;\n  height: 56px;\n  min-width: 56px;\n  min-height: 56px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.market-card-logo-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.market-card-logo-icon {\n  font-size: 28px;\n}\n\n.market-card-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.market-card-info {\n  min-width: 0;\n}\n\n.market-card-title-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 4px;\n}\n\n.market-card-title-row .market-card-name {\n  margin-bottom: 0;\n}\n\n.market-card-status-tag {\n  border-radius: 6px;\n  font-size: 11px;\n  line-height: 18px;\n  padding: 0 6px;\n  margin-right: 0;\n}\n\n.market-card-name {\n  font-size: 15px;\n  font-weight: 600;\n  color: #1a1a1a;\n  margin-bottom: 4px;\n}\n\n.market-status-radio-group .ant-radio-button-wrapper {\n  border-radius: 8px;\n  margin-right: 8px;\n  border-inline-start-width: 1px;\n}\n\n.market-status-radio-group .ant-radio-button-wrapper:first-child {\n  border-radius: 8px;\n}\n\n.market-status-radio-group .ant-radio-button-wrapper:last-child {\n  border-radius: 8px;\n  margin-right: 0;\n}\n\n.market-status-radio-group .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {\n  border-color: #35b558 !important;\n  color: #35b558 !important;\n  background-color: #f6ffed !important;\n}\n\n.market-card-location {\n  font-size: 13px;\n  color: #666;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.market-card-description {\n  color: #8c8c8c;\n  display: -webkit-box;\n  font-size: 12px;\n  line-height: 1.35;\n  margin-top: 4px;\n  max-width: 360px;\n  overflow: hidden;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n}\n\n.market-card-pin {\n  font-size: 12px;\n  color: #35b558;\n  flex-shrink: 0;\n}\n\n.market-card-actions {\n  display: flex;\n  gap: 8px;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.market-card-btn-edit {\n  color: #1890ff;\n  background: #e6f7ff;\n  border-radius: 8px;\n  font-size: 13px;\n}\n\n.market-card-btn-edit:hover {\n  color: #1890ff;\n  background: #bae7ff !important;\n}\n\n.market-card-btn-view {\n  color: #35b558;\n  background: #f6ffed;\n  border-radius: 8px;\n  font-size: 13px;\n}\n\n.market-card-btn-view:hover {\n  color: #35b558;\n  background: #d9f7be !important;\n}\n\n.market-card-btn-delete {\n  color: #ff4d4f;\n  background: #fff2f0;\n  border-radius: 8px;\n  font-size: 13px;\n}\n\n/* Market Stores page */\n.market-stores-heading-wrap {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.market-stores-back {\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #f5f5f5;\n  color: #1a1a1a;\n}\n\n.market-stores-back:hover {\n  background: #e8e8e8;\n  color: #1a1a1a;\n}\n\n.market-stores-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n}\n\n.market-stores-card {\n  background: #fff;\n  border-radius: 12px;\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.market-stores-card-right {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n.market-stores-card-left {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  min-width: 0;\n}\n\n.market-stores-card-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: #e8f5e9;\n  color: #35b558;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n.market-stores-card-image {\n  overflow: hidden;\n}\n\n.market-stores-card-image img {\n  height: 100%;\n  object-fit: cover;\n  width: 100%;\n}\n\n.market-stores-card-info {\n  min-width: 0;\n}\n\n.market-stores-card-name {\n  font-size: 14px;\n  font-weight: 700;\n  color: #1a1a1a;\n  margin-bottom: 2px;\n}\n\n.market-stores-card-owner,\n.market-stores-card-address {\n  font-size: 12px;\n  color: #666;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.market-stores-status {\n  font-size: 12px;\n  font-weight: 600;\n  color: #2e7d32;\n  background: #e8f5e9;\n  border-radius: 999px;\n  padding: 6px 10px;\n  flex-shrink: 0;\n}\n\n.market-stores-status--inactive {\n  color: #ad6800;\n  background: #fff7e6;\n}\n\n.market-stores-btn-review {\n  background: #f5f5f5;\n  border-color: #e8e8e8;\n  color: #1a1a1a;\n}\n\n.market-stores-btn-review:hover {\n  background: #e8e8e8 !important;\n  border-color: #e8e8e8 !important;\n  color: #1a1a1a !important;\n}\n\n@media (max-width: 768px) {\n  .market-stores-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.market-card-btn-delete:hover {\n  color: #ff4d4f;\n  background: #ffccc7 !important;\n}\n\n/* Rap card (uses Markets card base styles) */\n.rap-card-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  font-size: 13px;\n  color: #666;\n}\n\n.rap-card-meta-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n}\n\n.rap-card-meta-item .anticon {\n  color: #35b558;\n  font-size: 12px;\n  flex-shrink: 0;\n}\n\n@media (max-width: 768px) {\n  .markets-card-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.markets-empty-wrap .ant-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.markets-empty-wrap .ant-empty-image {\n  margin-bottom: 0;\n  flex-shrink: 0;\n}\n\n.markets-empty-wrap .ant-empty-description {\n  margin-top: 24px;\n  flex-shrink: 0;\n}\n\n.markets-empty-illustration {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  min-height: 220px;\n  box-sizing: border-box;\n}\n\n.markets-empty-phone {\n  position: relative;\n  width: 120px;\n  height: 200px;\n  border: 3px solid #35b558;\n  border-radius: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.markets-empty-bubble {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: #35b558;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  left: 28px;\n  top: -20px;\n}\n\n.markets-empty-store-icon {\n  font-size: 28px;\n  color: #fff;\n}\n\n.markets-empty-dot {\n  position: absolute;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #35b558;\n  opacity: 0.6;\n}\n\n.markets-empty-dot-1 {\n  top: 20px;\n  right: 12px;\n}\n\n.markets-empty-dot-2 {\n  bottom: 40px;\n  left: 10px;\n  background: #2196F3;\n}\n\n.markets-empty-dot-3 {\n  bottom: 80px;\n  right: 8px;\n  width: 6px;\n  height: 6px;\n}\n\n.markets-empty-star {\n  position: absolute;\n  font-size: 12px;\n  color: #35b558;\n  opacity: 0.8;\n}\n\n.markets-empty-star-1 {\n  top: 40px;\n  left: 8px;\n}\n\n.markets-empty-star-2 {\n  bottom: 60px;\n  right: 16px;\n  color: #2196F3;\n}\n\n.markets-empty-text {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.markets-empty-title {\n  font-size: 12px;\n  font-weight: 500;\n  color: #1a1a1a;\n  margin-bottom: 2px;\n}\n\n.markets-empty-subtitle {\n  font-size: 14px;\n  color: #666;\n  margin-top: 0;\n  display: block;\n}\n\n/* Add Mart Modal */\n/* Add Mart Modal - round corners */\n.modal-round .ant-modal-content {\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n.modal-round .ant-modal-header {\n  border-bottom: 1px solid #f0f0f0;\n  border-radius: 16px 16px 0 0;\n}\n\n.add-mart-modal .ant-modal-header {\n  border-bottom: 1px solid #f0f0f0;\n}\n\n/* Single upload box: placeholder and preview live in the same rounded box */\n.add-mart-upload-box {\n  width: 160px;\n  height: 160px;\n  margin: 0 auto;\n  border-radius: 50%;\n  border: 1px solid #e8e8e8;\n  background: #f5f5f5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  position: relative;\n}\n\n.add-mart-upload-box .ant-upload {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n}\n\n.add-mart-upload-box .ant-upload-select {\n  width: 100%;\n  height: 100%;\n  border: none;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.add-mart-upload-box .ant-upload-select:hover {\n  background: #ebebeb;\n}\n\n.add-mart-upload-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  text-align: center;\n  cursor: pointer;\n  width: 100%;\n  height: 100%;\n}\n\n.add-mart-upload-icon {\n  font-size: 40px;\n  color: #bfbfbf;\n  margin-bottom: 8px;\n}\n\n.add-mart-upload-text {\n  font-size: 12px;\n  color: #8c8c8c;\n  line-height: 1.2;\n}\n\n.add-mart-upload-preview {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f5f5f5;\n}\n\n.add-mart-upload-preview-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.add-mart-upload-remove {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(0, 0, 0, 0.55);\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  padding: 0;\n  transition: background 0.2s;\n  z-index: 1;\n}\n\n.add-mart-upload-remove:hover {\n  background: rgba(0, 0, 0, 0.7);\n}\n\n.add-mart-upload .ant-upload-list-item-container,\n.add-mart-upload .ant-upload-list-item {\n  border-radius: 12px;\n}\n\n.add-mart-modal-footer {\n  margin-top: 24px;\n  padding-top: 16px;\n  border-top: 1px solid #f0f0f0;\n  width: 100%;\n}\n\n.add-mart-modal-footer .ant-form-item-control {\n  width: 100%;\n  max-width: 100%;\n}\n\n.add-mart-modal-footer .ant-form-item-control-input-content {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n}\n\n.add-mart-modal .markets-add-btn {\n  width: 100%;\n  min-width: 0;\n  height: 45px;\n  display: block;\n}\n\n.market-location-form-item {\n  margin-bottom: 20px;\n}\n\n.market-location-picker {\n  background: #f8fbf9;\n  border: 1px solid #e7f3eb;\n  border-radius: 16px;\n  padding: 16px;\n}\n\n.market-location-picker-head {\n  align-items: flex-start;\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.market-location-picker-title {\n  color: #1f1f1f;\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.market-location-picker-subtitle {\n  color: #8c8c8c;\n  font-size: 13px;\n  line-height: 1.5;\n  margin-top: 3px;\n}\n\n.market-location-picker-alert {\n  border-radius: 10px;\n  margin-bottom: 12px;\n}\n\n.market-location-search .ant-input,\n.market-location-search .ant-input-group-addon .ant-btn {\n  height: 44px;\n}\n\n.market-location-search .ant-input {\n  border-radius: 12px 0 0 12px;\n}\n\n.market-location-search .ant-input-search-button {\n  background: #35b558 !important;\n  border-color: #35b558 !important;\n  border-radius: 0 12px 12px 0 !important;\n  font-weight: 600;\n}\n\n.market-location-results {\n  background: #fff;\n  border: 1px solid #edf2ef;\n  border-radius: 12px;\n  box-shadow: 0 8px 22px rgba(16, 24, 40, 0.08);\n  margin-top: 8px;\n  max-height: 190px;\n  overflow: auto;\n}\n\n.market-location-result {\n  align-items: flex-start;\n  background: transparent;\n  border: 0;\n  border-bottom: 1px solid #f2f4f3;\n  color: #4d5a52;\n  cursor: pointer;\n  display: flex;\n  gap: 10px;\n  line-height: 1.45;\n  padding: 10px 12px;\n  text-align: left;\n  width: 100%;\n}\n\n.market-location-result:last-child {\n  border-bottom: 0;\n}\n\n.market-location-result:hover {\n  background: #f4fbf6;\n  color: #2e7d32;\n}\n\n.market-location-result .anticon {\n  color: #35b558;\n  flex: 0 0 auto;\n  margin-top: 3px;\n}\n\n.market-location-map-wrap {\n  background: #eef4f0;\n  border: 1px solid #e1ece5;\n  border-radius: 14px;\n  height: 300px;\n  margin-top: 14px;\n  overflow: hidden;\n  position: relative;\n}\n\n.market-location-map {\n  height: 100%;\n  width: 100%;\n}\n\n.market-location-map-state {\n  align-items: center;\n  display: flex;\n  inset: 0;\n  justify-content: center;\n  position: absolute;\n  z-index: 1;\n}\n\n.market-location-coordinates {\n  display: grid;\n  gap: 12px;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  margin-top: 14px;\n}\n\n.market-location-coordinates div {\n  background: #fff;\n  border: 1px solid #edf2ef;\n  border-radius: 12px;\n  padding: 10px 12px;\n}\n\n.market-location-coordinates span {\n  color: #8c8c8c;\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.market-location-coordinates strong {\n  color: #1f1f1f;\n  display: block;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n@media (max-width: 575px) {\n  .market-location-picker {\n    padding: 12px;\n  }\n\n  .market-location-map-wrap {\n    height: 260px;\n  }\n\n  .market-location-coordinates {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Delete Mart Modal */\n.delete-mart-modal .ant-modal-content {\n  padding: 0;\n}\n\n.delete-mart-modal .ant-modal-close {\n  top: 16px;\n  right: 16px;\n}\n\n.delete-mart-close-icon {\n  color: #ff4d4f !important;\n  font-size: 18px;\n}\n\n.delete-mart-hero {\n  position: relative;\n  height: 180px;\n  background: #fff2f0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.delete-mart-hero-icon {\n  width: 72px;\n  height: 72px;\n  border-radius: 18px;\n  background: #ffe4e6;\n  color: #ff4d4f;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 34px;\n}\n\n.delete-mart-hero-wave {\n  position: absolute;\n  left: -10%;\n  right: -10%;\n  bottom: -40px;\n  height: 120px;\n  background: #fff;\n  border-top-left-radius: 60% 80%;\n  border-top-right-radius: 60% 80%;\n}\n\n.delete-mart-content {\n  padding: 28px 28px 32px;\n  text-align: center;\n}\n\n.delete-mart-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #1a1a1a;\n  margin-bottom: 8px;\n}\n\n.delete-mart-subtitle {\n  font-size: 14px;\n  color: #8c8c8c;\n  line-height: 1.45;\n  margin-bottom: 22px;\n}\n\n.delete-mart-btn {\n  width: 70%;\n  max-width: 360px;\n  border-radius: 999px;\n  height: 44px;\n  font-weight: 600;\n}\n\n.market-detail {\n  display: grid;\n  gap: 18px;\n}\n\n.market-detail-loading {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  min-height: 240px;\n}\n\n.market-detail-logo {\n  border-radius: 12px;\n  height: 220px !important;\n  object-fit: cover;\n  width: 100% !important;\n}\n\n/* ========== Store Approval module ========== */\n.store-approval-card {\n  background: transparent;\n}\n\n.store-approval-card-header {\n  margin-bottom: 10px;\n}\n\n.store-approval-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #1a1a1a;\n}\n\n.store-approval-count {\n  font-weight: 500;\n  color: #666;\n  margin-left: 4px;\n}\n\n.store-approval-tabs {\n  display: flex;\n  gap: 14px;\n  align-items: center;\n  margin: 10px 0 18px;\n  flex-wrap: wrap;\n}\n\n.store-approval-tab {\n  height: 40px;\n  padding: 0 18px;\n  border-radius: 10px;\n  border: 1px solid #f0f0f0;\n  background: #fff;\n  color: #666;\n  font-weight: 600;\n}\n\n.store-approval-tab--active {\n  background: #35b558 !important;\n  border-color: #35b558 !important;\n  color: #fff !important;\n}\n\n.store-approval-tab-count {\n  margin-left: 6px;\n  font-weight: 500;\n  opacity: 0.9;\n}\n\n.store-approval-body {\n  min-height: calc(100vh - 260px);\n}\n\n.store-approval-loading {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  min-height: 280px;\n}\n\n.store-approval-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n  width: 100%;\n}\n\n.store-approval-item-card {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 16px;\n  background: #fff;\n  border: 1px solid #f0f0f0;\n  border-radius: 12px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);\n  min-width: 0;\n}\n\n.store-approval-item-logo-wrap {\n  position: relative;\n  flex-shrink: 0;\n}\n\n.store-approval-item-logo {\n  width: 58px;\n  height: 58px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.store-approval-item-logo-badge {\n  position: absolute;\n  top: -4px;\n  right: -4px;\n  font-size: 18px;\n  color: #52c41a;\n  background: #fff;\n  border-radius: 50%;\n  line-height: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.store-approval-item-logo-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.store-approval-item-logo-icon {\n  font-size: 26px;\n  color: #35b558;\n}\n\n.store-approval-item-mid {\n  flex: 1;\n  min-width: 0;\n}\n\n.store-approval-item-name {\n  font-size: 14px;\n  font-weight: 700;\n  color: #1a1a1a;\n  margin-bottom: 6px;\n}\n\n.store-approval-item-owner {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #666;\n  font-size: 12px;\n}\n\n.store-approval-item-owner-name {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 160px;\n}\n\n.store-approval-item-actions {\n  display: flex;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.store-approval-btn {\n  height: 32px;\n  padding: 0 14px;\n  border-radius: 10px;\n  border: none;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.store-approval-btn-approve {\n  background: #eafff1;\n  color: #35b558;\n}\n\n.store-approval-btn-approve:hover {\n  background: #d4ffe3 !important;\n  color: #2da24e !important;\n}\n\n.store-approval-btn-decline {\n  background: #fff0f0;\n  color: #ff4d4f;\n}\n\n.store-approval-btn-decline:hover {\n  background: #ffd6d6 !important;\n  color: #ff4d4f !important;\n}\n\n.store-approval-btn-review {\n  background: #f5f5f5;\n  color: #1a1a1a;\n}\n\n.store-approval-btn-review:hover {\n  background: #e8e8e8 !important;\n  color: #1a1a1a !important;\n}\n\n.store-approval-item-card .store-approval-item-mid[role=\"button\"],\n.store-approval-item-card .store-approval-item-logo-wrap[role=\"button\"] {\n  cursor: pointer;\n}\n\n/* Store Review Drawer */\n.store-review-drawer .ant-drawer-content-wrapper {\n  box-shadow: -4px 0 16px rgba(0, 0, 0, 0.08);\n}\n\n/* Store Approve/Decline confirmation modal (matches project style) */\n.store-action-modal .ant-modal-content {\n  padding: 0;\n}\n\n.store-action-modal .ant-modal-close {\n  top: 16px;\n  right: 16px;\n}\n\n.store-action-close-icon {\n  color: #ff4d4f !important;\n  font-size: 18px;\n}\n\n.store-action-hero {\n  position: relative;\n  height: 180px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.store-action-modal--approve .store-action-hero {\n  background: #f6ffed;\n}\n\n.store-action-modal--decline .store-action-hero {\n  background: #fff2f0;\n}\n\n.store-action-hero-icon {\n  width: 72px;\n  height: 72px;\n  border-radius: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 34px;\n}\n\n.store-action-modal--approve .store-action-hero-icon {\n  background: #e8f5e9;\n  color: #35b558;\n}\n\n.store-action-modal--decline .store-action-hero-icon {\n  background: #ffe4e6;\n  color: #ff4d4f;\n}\n\n.store-action-hero-wave {\n  position: absolute;\n  left: -10%;\n  right: -10%;\n  bottom: -40px;\n  height: 120px;\n  background: #fff;\n  border-top-left-radius: 60% 80%;\n  border-top-right-radius: 60% 80%;\n}\n\n.store-action-content {\n  padding: 28px 28px 32px;\n  text-align: center;\n}\n\n.store-action-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #1a1a1a;\n  margin-bottom: 8px;\n}\n\n.store-action-subtitle {\n  font-size: 14px;\n  color: #8c8c8c;\n  line-height: 1.45;\n  margin-bottom: 22px;\n}\n\n.store-action-btn {\n  width: 70%;\n  max-width: 360px;\n  border-radius: 999px;\n  height: 44px;\n  font-weight: 600;\n  border: none;\n}\n\n.store-action-btn--approve {\n  background: #35b558 !important;\n}\n\n.store-action-btn--approve:hover {\n  background: #2da24e !important;\n}\n\n.store-action-btn--decline {\n  background: #ff4d4f !important;\n}\n\n.store-action-btn--decline:hover {\n  background: #ff7875 !important;\n}\n\n.store-review-drawer-inner {\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n}\n\n.store-review-header {\n  position: relative;\n  padding: 20px 24px 24px;\n  background: linear-gradient(135deg, #2e7d32 0%, #388e3c 50%, #43a047 100%);\n  border-radius: 0;\n}\n\n.store-review-header-pattern {\n  position: absolute;\n  inset: 0;\n  opacity: 0.08;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 20 Q10 10 20 20 T40 20' stroke='%23fff' fill='none' stroke-width='1'/%3E%3C/svg%3E\");\n}\n\n.store-review-profile {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.store-review-logo {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n.store-review-logo img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.store-review-logo-icon {\n  font-size: 24px;\n  color: rgba(0, 0, 0, 0.6);\n}\n\n.store-review-profile-text {\n  min-width: 0;\n}\n\n.store-review-approved-tag {\n  margin-top: 8px;\n  border-radius: 999px;\n  font-weight: 600;\n}\n\n.store-review-store-name {\n  font-size: 18px;\n  font-weight: 600;\n  color: #fff;\n  margin-bottom: 4px;\n}\n\n.store-review-owner {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.store-review-owner .ant-avatar {\n  flex-shrink: 0;\n}\n\n.store-review-section {\n  padding: 16px 24px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.store-review-section:last-of-type {\n  border-bottom: none;\n}\n\n.store-review-section-label {\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #666;\n  margin-bottom: 8px;\n}\n\n.store-review-privacy {\n  font-size: 12px;\n  line-height: 1.5;\n  color: #666;\n  margin: 0;\n}\n\n.store-review-docs {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.store-review-doc-card {\n  border: 1px solid #e8e8e8;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #fafafa;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 118px;\n}\n\n.store-review-doc-title {\n  width: 100%;\n  padding: 7px 8px;\n  background: #f6ffed;\n  color: #2e7d32;\n  font-size: 11px;\n  font-weight: 700;\n  text-align: center;\n}\n\n.store-review-doc-card a {\n  display: block;\n  width: 100%;\n  flex: 1;\n  min-height: 88px;\n}\n\n.store-review-doc-card img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.store-review-doc-placeholder {\n  flex: 1;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  color: #999;\n  text-align: center;\n  padding: 12px;\n}\n\n.store-review-state {\n  min-height: 180px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 12px;\n  color: #8c8c8c;\n}\n\n.store-review-owner-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.store-review-owner-row {\n  display: grid;\n  grid-template-columns: 120px 1fr;\n  gap: 8px;\n  font-size: 13px;\n}\n\n.store-review-owner-label {\n  color: #666;\n}\n\n.store-review-owner-value {\n  color: #1a1a1a;\n  word-break: break-word;\n}\n\n.store-review-footer {\n  margin-top: auto;\n  padding: 16px 24px 24px;\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n.store-review-footer-decline {\n  background: #fff0f0;\n  color: #ff4d4f;\n  border-color: #ff4d4f;\n}\n\n.store-review-footer-decline:hover {\n  background: #ffd6d6 !important;\n  color: #ff4d4f !important;\n  border-color: #ff4d4f !important;\n}\n\n.store-review-footer-approve {\n  background: #2e7d32 !important;\n  border-color: #2e7d32 !important;\n}\n\n.store-review-footer-approve:hover {\n  background: #388e3c !important;\n  border-color: #388e3c !important;\n}\n\n@media (max-width: 768px) {\n  .store-approval-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .store-review-docs {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ========== Product Category ========== */\n.product-category-card {\n  background: transparent;\n}\n\n.product-category-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.product-category-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #1a1a1a;\n}\n\n.product-category-count {\n  font-weight: 500;\n  color: #666;\n  margin-left: 4px;\n}\n\n.product-category-create-btn {\n  background: #35b558 !important;\n  border-color: #35b558 !important;\n  font-weight: 500;\n  height: 45px;\n}\n\n.product-category-create-btn:hover {\n  background: #2e9d4a !important;\n  border-color: #2e9d4a !important;\n}\n\n/* ========== Add Rap ========== */\n.raps-card {\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);\n  padding: 16px;\n}\n\n.raps-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.raps-card-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.raps-card-count {\n  font-weight: 500;\n  color: #666;\n}\n\n.product-category-body {\n  min-height: 320px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.product-category-loading {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  min-height: 320px;\n  width: 100%;\n}\n\n.product-category-body .ant-empty {\n  padding: 24px 0;\n}\n\n.product-category-body .ant-empty-description {\n  margin-top: 24px;\n}\n\n/* Product Category grid and cards */\n.product-category-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  gap: 20px;\n  width: 100%;\n}\n\n.product-category-item-card {\n  background: #fff;\n  border-radius: 12px;\n  padding: 16px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.product-category-item-image {\n  width: 100%;\n  aspect-ratio: 1;\n  max-width: 140px;\n  margin: 0 auto 12px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.product-category-item-image-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.product-category-item-icon {\n  font-size: 48px;\n  line-height: 1;\n}\n\n.product-category-item-name {\n  font-size: 15px;\n  font-weight: 600;\n  color: #1a1a1a;\n  margin-bottom: 12px;\n}\n\n.product-category-item-actions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  justify-content: center;\n}\n\n.product-category-item-btn {\n  width: 36px !important;\n  height: 36px !important;\n  padding: 0 !important;\n  border-radius: 50% !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.product-category-item-btn-edit {\n  color: #1890ff !important;\n  background: #e6f7ff !important;\n}\n\n.product-category-item-btn-edit:hover {\n  color: #1890ff !important;\n  background: #bae7ff !important;\n}\n\n.product-category-item-btn-delete {\n  color: #ff4d4f !important;\n  background: #fff2f0 !important;\n}\n\n.product-category-item-btn-delete:hover {\n  color: #ff4d4f !important;\n  background: #ffccc7 !important;\n}\n\n/* Product Category empty state illustration */\n.product-category-empty-illustration {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  min-height: 220px;\n  box-sizing: border-box;\n}\n\n.product-category-empty-phone {\n  position: relative;\n  width: 120px;\n  height: 200px;\n  border: 3px solid #35b558;\n  border-radius: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.product-category-empty-bubble {\n  position: absolute;\n  inset: 12px;\n  border-radius: 16px;\n  background: linear-gradient(145deg, #52c41a 0%, #35b558 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.product-category-empty-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-template-rows: 1fr 1fr;\n  gap: 6px;\n  padding: 8px;\n}\n\n.product-category-empty-icon {\n  width: 18px;\n  height: 18px;\n  background: rgba(255, 255, 255, 0.9);\n  border-radius: 4px;\n}\n\n.product-category-empty-sparkle {\n  position: absolute;\n  font-size: 10px;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.product-category-empty-sparkle-1 {\n  top: 8px;\n  right: 10px;\n}\n\n.product-category-empty-sparkle-2 {\n  bottom: 10px;\n  left: 8px;\n}\n\n.product-category-empty-dot {\n  position: absolute;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #35b558;\n  opacity: 0.6;\n}\n\n.product-category-empty-dot-1 {\n  top: 20px;\n  right: 12px;\n}\n\n.product-category-empty-dot-2 {\n  bottom: 40px;\n  left: 10px;\n  background: #2196F3;\n}\n\n.product-category-empty-dot-3 {\n  bottom: 80px;\n  right: 8px;\n  width: 6px;\n  height: 6px;\n}\n\n.product-category-empty-star {\n  position: absolute;\n  font-size: 12px;\n  color: #35b558;\n  opacity: 0.8;\n}\n\n.product-category-empty-star-1 {\n  top: 40px;\n  left: 8px;\n}\n\n.product-category-empty-star-2 {\n  bottom: 60px;\n  right: 16px;\n  color: #2196F3;\n}\n\n.product-category-empty-text {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.product-category-empty-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #1a1a1a;\n  margin-bottom: 8px;\n}\n\n.product-category-empty-subtitle {\n  font-size: 14px;\n  color: #666;\n  margin: 0;\n}\n\n/* Add Category Modal */\n.add-category-close-icon {\n  color: #ff4d4f !important;\n  font-size: 18px;\n}\n\n.add-category-modal .ant-modal-header {\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.add-category-modal-footer {\n  margin-bottom: 0;\n}\n\n.add-category-submit-btn {\n  width: 100%;\n  background: #35b558 !important;\n  border-color: #35b558 !important;\n  font-weight: 500;\n  height: 48px;\n  font-size: 16px;\n}\n\n.add-category-submit-btn:hover {\n  background: #2e9d4a !important;\n  border-color: #2e9d4a !important;\n}\n\n/* Delete Category (confirm) Modal */\n.delete-category-modal .ant-modal-content {\n  padding: 0;\n}\n\n.delete-category-modal .ant-modal-close {\n  top: 16px;\n  right: 16px;\n}\n\n.delete-category-close-icon {\n  color: #ff4d4f !important;\n  font-size: 18px;\n}\n\n.delete-category-hero {\n  position: relative;\n  height: 180px;\n  background: #fff2f0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.delete-category-hero-icon {\n  width: 72px;\n  height: 72px;\n  border-radius: 18px;\n  background: #ffe4e6;\n  color: #ff4d4f;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 34px;\n}\n\n.delete-category-hero-wave {\n  position: absolute;\n  left: -10%;\n  right: -10%;\n  bottom: -40px;\n  height: 120px;\n  background: #fff;\n  border-top-left-radius: 60% 80%;\n  border-top-right-radius: 60% 80%;\n}\n\n.delete-category-content {\n  padding: 28px 28px 32px;\n  text-align: center;\n}\n\n.delete-category-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #1a1a1a;\n  margin-bottom: 8px;\n}\n\n.delete-category-subtitle {\n  font-size: 14px;\n  color: #8c8c8c;\n  line-height: 1.45;\n  margin-bottom: 22px;\n}\n\n.delete-category-btn {\n  width: 70%;\n  max-width: 360px;\n  border-radius: 999px;\n  height: 44px;\n  font-weight: 600;\n}\n\n/* Category Deleted (success) Modal */\n.category-deleted-modal .ant-modal-content {\n  padding: 0;\n}\n\n.category-deleted-modal .ant-modal-close {\n  top: 16px;\n  right: 16px;\n}\n\n.category-deleted-close-icon {\n  color: #ff4d4f !important;\n  font-size: 18px;\n}\n\n.category-deleted-hero {\n  position: relative;\n  height: 160px;\n  background: #fff5f5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.category-deleted-hero-shapes {\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(circle at 20% 50%, rgba(255, 182, 193, 0.4) 0%, transparent 50%),\n    radial-gradient(circle at 80% 30%, rgba(255, 192, 203, 0.35) 0%, transparent 45%),\n    radial-gradient(circle at 50% 80%, rgba(255, 182, 193, 0.3) 0%, transparent 40%);\n  pointer-events: none;\n}\n\n.category-deleted-hero-icon {\n  position: relative;\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  border: 3px solid #ff4d4f;\n  color: #ff4d4f;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 36px;\n  background: #fff;\n}\n\n.category-deleted-content {\n  padding: 24px 28px 32px;\n  text-align: center;\n}\n\n.category-deleted-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #1a1a1a;\n  margin-bottom: 8px;\n}\n\n.category-deleted-subtitle {\n  font-size: 14px;\n  color: #8c8c8c;\n  line-height: 1.45;\n  margin-bottom: 22px;\n}\n\n.category-deleted-btn {\n  width: 70%;\n  max-width: 360px;\n  border-radius: 999px;\n  height: 44px;\n  font-weight: 600;\n}\n\n/* ========== Approved Vendors ========== */\n.approved-vendors-card {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  overflow: hidden;\n}\n\n.approved-vendors-header {\n  padding: 20px 24px 16px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.approved-vendors-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #1a1a1a;\n}\n\n.approved-vendors-count {\n  font-weight: 500;\n  color: #666;\n  margin-left: 4px;\n}\n\n.approved-vendors-table .ant-table {\n  font-size: 14px;\n}\n\n.approved-vendors-table .ant-table-thead>tr>th {\n  background: #fafafa;\n  font-weight: 600;\n  color: #666;\n  padding: 14px 16px;\n}\n\n.approved-vendors-table .ant-table-tbody>tr>td {\n  padding: 16px;\n  vertical-align: middle;\n}\n\n.approved-vendors-table .ant-table-tbody>tr:hover>td {\n  background: #fafafa;\n}\n\n.approved-vendors-cell-vendor {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.approved-vendors-vendor-info {\n  min-width: 0;\n}\n\n.approved-vendors-vendor-name {\n  font-weight: 600;\n  color: #1a1a1a;\n  margin-bottom: 2px;\n}\n\n.approved-vendors-vendor-mart {\n  font-size: 13px;\n  color: #666;\n}\n\n.approved-vendors-cell-email,\n.approved-vendors-cell-phone {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.approved-vendors-icon-email {\n  color: #fa8c16;\n  font-size: 14px;\n  flex-shrink: 0;\n}\n\n.approved-vendors-icon-phone,\n.approved-vendors-icon-pin {\n  color: #35b558;\n  font-size: 14px;\n  flex-shrink: 0;\n}\n\n.approved-vendors-cell-mart {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.approved-vendors-mart-logo,\n.approved-vendors-store-logo {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  overflow: hidden;\n  color: rgba(0, 0, 0, 0.6);\n  font-size: 18px;\n}\n\n.approved-vendors-mart-logo img,\n.approved-vendors-store-logo img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.approved-vendors-mart-info {\n  min-width: 0;\n}\n\n.approved-vendors-mart-name {\n  font-weight: 500;\n  color: #1a1a1a;\n  margin-bottom: 2px;\n}\n\n.approved-vendors-mart-address {\n  font-size: 12px;\n  color: #666;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.approved-vendors-cell-store {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.approved-vendors-store-name {\n  font-weight: 500;\n  color: #1a1a1a;\n}\n\n.approved-vendors-table .ant-pagination-item-active {\n  background: #35b558 !important;\n  border-color: #35b558 !important;\n}\n\n.approved-vendors-table .ant-pagination-item-active a {\n  color: #fff !important;\n}\n\n.approved-vendors-table .ant-pagination-item:hover a,\n.approved-vendors-table .ant-pagination-next:hover .ant-pagination-item-link,\n.approved-vendors-table .ant-pagination-prev:hover .ant-pagination-item-link {\n  color: #35b558;\n}\n\n/* Approved Vendors empty state */\n.approved-vendors-empty-wrap {\n  min-height: 400px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 24px;\n}\n\n.approved-vendors-empty-wrap .ant-empty-description {\n  margin-top: 24px;\n}\n\n.approved-vendors-empty-illustration {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  min-height: 220px;\n  box-sizing: border-box;\n}\n\n.approved-vendors-empty-phone {\n  position: relative;\n  width: 120px;\n  height: 200px;\n  border: 3px solid #35b558;\n  border-radius: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.approved-vendors-empty-bubble {\n  position: absolute;\n  inset: 12px;\n  border-radius: 16px;\n  background: linear-gradient(145deg, #52c41a 0%, #35b558 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.approved-vendors-empty-person-icon {\n  font-size: 48px;\n  color: #fff;\n  position: relative;\n  z-index: 1;\n}\n\n.approved-vendors-empty-sparkle {\n  position: absolute;\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.95);\n}\n\n.approved-vendors-empty-sparkle-1 {\n  top: 12px;\n  left: 14px;\n}\n\n.approved-vendors-empty-sparkle-2 {\n  bottom: 14px;\n  right: 12px;\n}\n\n.approved-vendors-empty-dot {\n  position: absolute;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #35b558;\n  opacity: 0.6;\n}\n\n.approved-vendors-empty-dot-1 {\n  top: 20px;\n  right: 12px;\n}\n\n.approved-vendors-empty-dot-2 {\n  bottom: 40px;\n  left: 10px;\n  background: #2196F3;\n}\n\n.approved-vendors-empty-dot-3 {\n  bottom: 80px;\n  right: 8px;\n  width: 6px;\n  height: 6px;\n}\n\n.approved-vendors-empty-star {\n  position: absolute;\n  font-size: 12px;\n  color: #35b558;\n  opacity: 0.8;\n}\n\n.approved-vendors-empty-star-1 {\n  top: 40px;\n  left: 8px;\n}\n\n.approved-vendors-empty-star-2 {\n  bottom: 60px;\n  right: 16px;\n  color: #2196F3;\n}\n\n.approved-vendors-empty-text {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.approved-vendors-empty-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #1a1a1a;\n  margin-bottom: 8px;\n}\n\n.approved-vendors-empty-subtitle {\n  font-size: 14px;\n  color: #666;\n  margin: 0;\n}\n\n.approved-vendors-notification-btn {\n  width: 40px;\n  height: 40px;\n  border: none;\n  border-radius: 10px;\n  background: #fff7e6;\n  color: #fa8c16;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 18px;\n  transition: background 0.2s, color 0.2s;\n}\n\n.approved-vendors-notification-btn:hover {\n  background: #ffd591;\n  color: #d46b08;\n}\n\n/* Notification Modal (Approved Vendors) */\n.notification-modal-close-icon {\n  color: #ff4d4f !important;\n  font-size: 18px;\n}\n\n.notification-modal .ant-modal-header {\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.notification-modal-body {\n  padding: 8px 0 0;\n}\n\n.notification-modal-textarea {\n  margin-bottom: 20px;\n  border-radius: 8px;\n}\n\n.notification-modal-textarea.ant-input {\n  font-size: 14px;\n}\n\n.notification-modal-send-btn {\n  width: 100%;\n  height: 48px;\n  font-size: 16px;\n  font-weight: 500;\n  background: #35b558 !important;\n  border-color: #35b558 !important;\n}\n\n.notification-modal-send-btn:hover {\n  background: #2e9d4a !important;\n  border-color: #2e9d4a !important;\n}\n\n/* ========== Cmslayout Dashboard (light sidebar + IYE branding) ========== */\n.cmslayout-dashboard .cmslayout-sider-light {\n  background: #fff !important;\n  box-shadow: none;\n}\n\n.cmslayout-brand {\n  height: 110px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border-bottom: none;\n}\n\n.cmslayout-brand-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  background: #35b558;\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n.cmslayout-brand-text {\n  font-size: 20px;\n  font-weight: 700;\n  color: #35b558;\n}\n\n.cmslayout-brand-logo {\n  height: 150px;\n  width: auto;\n  max-width: 100%;\n  object-fit: contain;\n  display: block;\n  margin: 0 auto;\n  transition: height 0.2s ease-in-out, width 0.2s ease-in-out;\n}\n\n.ant-layout-sider-collapsed .cmslayout-brand-logo {\n  height: 40px;\n  width: auto;\n  max-width: 100%;\n}\n\n@media (max-width: 992px) {\n  .cmslayout-brand-logo {\n    height: 68px;\n  }\n}\n\n@media (max-width: 576px) {\n  .cmslayout-brand-logo {\n    height: 40px;\n  }\n}\n\n.cmslayout-menu-light.ant-menu-light {\n  background: #fff !important;\n  border-right: none !important;\n  padding: 16px 0;\n}\n\n.cmslayout-menu-light .ant-menu-item {\n  margin: 12px 24px 12px 16px;\n  border-radius: 12px;\n  height: 48px;\n  line-height: 48px;\n  color: #a0a0a0;\n  font-weight: 500;\n}\n\n.cmslayout-menu-light .ant-menu-item a {\n  color: inherit;\n}\n\n.cmslayout-menu-light .ant-menu-item:hover,\n.cmslayout-menu-light .ant-menu-item:hover a {\n  color: #35b558;\n}\n\n.cmslayout-menu-light .ant-menu-item-selected {\n  background: #ebfaeb !important;\n  color: #35b558 !important;\n  font-weight: 600;\n  position: relative;\n  border-radius: 0 24px 24px 0;\n  margin: 12px 24px 12px 0;\n  padding-left: 28px !important;\n}\n\n.cmslayout-menu-light .ant-menu-item-selected::after {\n  content: '';\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 6px;\n  height: 100%;\n  background: #35b558;\n  border-radius: 0 24px 24px 0;\n  transform: none;\n}\n\n.cmslayout-menu-light .ant-menu-item-selected a {\n  color: #35b558 !important;\n}\n\n.cmslayout-menu-light .ant-menu-submenu-title {\n  margin: 12px 24px 12px 16px !important;\n  border-radius: 12px;\n  height: 48px !important;\n  line-height: 48px !important;\n  color: #a0a0a0 !important;\n  font-weight: 500;\n}\n\n.cmslayout-menu-light .ant-menu-submenu-title:hover {\n  color: #35b558 !important;\n}\n\n.cmslayout-menu-light .ant-menu-submenu-selected>.ant-menu-submenu-title {\n  color: #35b558 !important;\n}\n\n.cmslayout-menu-light .ant-menu-sub.ant-menu-inline {\n  background: #fff !important;\n}\n\n.cmslayout-menu-light .ant-menu-sub.ant-menu-inline .ant-menu-item {\n  height: auto;\n  min-height: 42px;\n  line-height: 1.25;\n  margin-top: 6px;\n  margin-bottom: 6px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.cmslayout-content-wrap {\n  /* background: #f4f7f6; */\n  padding: 0;\n}\n\n/* ========== Data-lite Rep Dashboard pages ========== */\n.data-lite-page,\n.data-lite-panel {\n  background: #fff;\n  border-radius: 20px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);\n  padding: 24px;\n}\n\n.data-lite-stack {\n  display: grid;\n  gap: 16px;\n  background: transparent;\n  box-shadow: none;\n  padding: 0;\n}\n\n.data-lite-section-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 18px;\n}\n\n.data-lite-section-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #1a1a1a;\n  margin: 0;\n}\n\n.data-lite-section-description {\n  font-size: 13px;\n  color: #777;\n  margin-top: 4px;\n  max-width: 680px;\n}\n\n.data-lite-section-action {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.data-lite-table-wrap {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.data-lite-table {\n  width: 100%;\n  min-width: 560px;\n  border-collapse: collapse;\n  color: #1f1f1f;\n}\n\n.data-lite-table th,\n.data-lite-table td {\n  border-bottom: 1px solid #eef1f0;\n  padding: 14px 12px;\n  text-align: left;\n  vertical-align: middle;\n  font-size: 14px;\n}\n\n.data-lite-table th {\n  color: #6f7b76;\n  font-weight: 700;\n  background: #f8fbfa;\n  white-space: nowrap;\n}\n\n.data-lite-table tr:last-child td {\n  border-bottom: none;\n}\n\n.data-lite-number-cell {\n  text-align: right !important;\n  white-space: nowrap;\n}\n\n.progress-text-bar {\n  display: inline-block;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", monospace;\n  color: #245d38;\n  background: #f1faf3;\n  border: 1px solid #d7f0dd;\n  border-radius: 8px;\n  padding: 6px 8px;\n  white-space: nowrap;\n}\n\n.data-lite-empty {\n  min-height: 180px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.vendor-action {\n  display: inline-flex;\n  align-items: center;\n  min-height: 30px;\n  border-radius: 999px;\n  padding: 4px 10px;\n  font-size: 12px;\n  font-weight: 700;\n  background: #f4f7f6;\n  color: #52615b;\n  white-space: nowrap;\n}\n\n.vendor-action.warn-vendor {\n  background: #fff6e0;\n  color: #9a6400;\n}\n\n.vendor-action.consider-delisting {\n  background: #fff0f0;\n  color: #b63436;\n}\n\n.review-filter-group {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.review-filter-group .ant-btn-primary {\n  background: #35b558;\n  border-color: #35b558;\n}\n\n.review-list {\n  display: grid;\n  gap: 12px;\n}\n\n.review-card {\n  border: 1px solid #eef1f0;\n  border-radius: 12px;\n  padding: 16px;\n  background: #fff;\n}\n\n.review-card-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 14px;\n}\n\n.review-card-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #1a1a1a;\n  margin: 0;\n}\n\n.review-card-meta,\n.review-card-order,\n.review-card-full {\n  font-size: 13px;\n  color: #6f7b76;\n}\n\n.review-card-meta {\n  margin-top: 4px;\n}\n\n.review-card-order {\n  margin-top: 10px;\n}\n\n.review-card-full {\n  color: #333;\n  margin-top: 12px;\n  line-height: 1.55;\n}\n\n.review-rating {\n  flex: 0 0 auto;\n  border-radius: 999px;\n  padding: 4px 9px;\n  background: #edf8ef;\n  color: #247a3a;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.review-rating.is-flagged {\n  background: #fff0f0;\n  color: #b63436;\n}\n\n.review-view-more.ant-btn-link {\n  padding: 0;\n  height: auto;\n  margin-top: 12px;\n  color: #35b558;\n  font-weight: 700;\n}\n\n@media (max-width: 767px) {\n\n  .data-lite-page,\n  .data-lite-panel {\n    border-radius: 14px;\n    padding: 16px;\n  }\n\n  .data-lite-section-header {\n    gap: 12px;\n  }\n\n  .data-lite-section-action,\n  .review-filter-group {\n    width: 100%;\n  }\n\n  .review-filter-group .ant-btn {\n    flex: 1 1 130px;\n  }\n\n  .data-lite-table {\n    min-width: 0;\n  }\n\n  .data-lite-table thead {\n    display: none;\n  }\n\n  .data-lite-table,\n  .data-lite-table tbody,\n  .data-lite-table tr,\n  .data-lite-table td {\n    display: block;\n    width: 100%;\n  }\n\n  .data-lite-table tr {\n    border: 1px solid #eef1f0;\n    border-radius: 12px;\n    padding: 10px 12px;\n    margin-bottom: 10px;\n  }\n\n  .data-lite-table td {\n    display: flex;\n    justify-content: space-between;\n    gap: 12px;\n    border-bottom: none;\n    padding: 5px 0;\n  }\n\n  .data-lite-table td::before {\n    content: attr(data-label);\n    color: #6f7b76;\n    font-weight: 700;\n    flex: 0 0 38%;\n  }\n\n  .data-lite-number-cell {\n    text-align: left !important;\n  }\n\n  .progress-text-bar {\n    max-width: 100%;\n    overflow-wrap: anywhere;\n  }\n}\n\n/* ========== CMS top bar (global) ========== */\n.cms-topbar.ant-layout-header {\n  height: auto !important;\n  line-height: initial !important;\n  padding: 0 !important;\n  background: #ffffff !important;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);\n  position: sticky;\n  top: 0;\n  z-index: 20;\n}\n\n.cms-topbar-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 20px;\n}\n\n.cms-topbar-spacer {\n  flex: 1;\n}\n\n.cms-logout-btn {\n  background: #35b558 !important;\n  border-color: #35b558 !important;\n  border-radius: 10px !important;\n  font-weight: 600;\n}\n\n.cms-logout-btn:hover {\n  background: #2da24e !important;\n  border-color: #2da24e !important;\n}\n\n\n/* TextField Styling */\n.markets-search.ant-input-affix-wrapper {\n  width: 420px;\n  height: 50px;\n  border-radius: 30px;\n  border: none !important;\n  box-shadow: none !important;\n  background: #FFFFFF;\n  padding: 0 20px;\n  display: flex;\n  align-items: center;\n}\n\n.markets-search.ant-input-affix-wrapper:hover,\n.markets-search.ant-input-affix-wrapper:focus,\n.markets-search.ant-input-affix-wrapper-focused {\n  border: none !important;\n  box-shadow: none !important;\n  background: #FFFFFF;\n}\n\n.markets-search .ant-input {\n  background: transparent;\n  border: none;\n  box-shadow: none;\n  font-size: 16px;\n}\n\n.markets-search .ant-input::placeholder {\n  color: #cfcfcf;\n  font-size: 16px;\n  font-weight: 400;\n}\n\n.markets-search .ant-input-prefix {\n  margin-right: 18px;\n  display: flex;\n  align-items: center;\n}\n\n.markets-search-icon {\n  font-size: 16px;\n  color: #fff;\n  background: #35c759;\n  border-radius: 50%;\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.approved-vendors-card {\n  padding: 24px;\n  overflow: hidden;\n}\n\n.approved-vendors-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 24px;\n  margin-bottom: 24px;\n  padding: 4px 0 10px;\n}\n\n.approved-vendors-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #1f1f1f;\n  margin: 0;\n  white-space: nowrap;\n}\n\n.approved-vendors-count {\n  color: #666;\n  font-weight: 500;\n}\n\n.approved-vendors-search-box {\n  width: 360px;\n  flex-shrink: 0;\n}\n\n.approved-vendors-search-input.ant-input-affix-wrapper {\n  height: 58px;\n  border: none !important;\n  box-shadow: none !important;\n  background: #f7f8fa !important;\n  border-radius: 18px;\n  padding: 0 18px;\n}\n\n.approved-vendors-search-input.ant-input-affix-wrapper:hover,\n.approved-vendors-search-input.ant-input-affix-wrapper:focus,\n.approved-vendors-search-input.ant-input-affix-wrapper-focused {\n  border: none !important;\n  box-shadow: none !important;\n  background: #f7f8fa !important;\n}\n\n.approved-vendors-search-input .ant-input {\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  font-size: 16px;\n  color: #1f1f1f;\n}\n\n.approved-vendors-search-input .ant-input::placeholder {\n  color: #b9b9b9;\n}\n\n.approved-vendors-search-input .ant-input-prefix {\n  margin-right: 12px;\n  display: flex;\n  align-items: center;\n}\n\n.approved-vendors-search-icon {\n  font-size: 18px;\n  color: #fff;\n  background: #35c759;\n  border-radius: 50%;\n  padding: 9px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* ==================================================== */\n/* Sidebar Collapse Trigger Overrides */\n/* ==================================================== */\n\n.cmslayout-sider-light .ant-layout-sider-trigger {\n  background: #ffffff !important;\n  color: #8c8c8c !important;\n  border-top: 1px solid #f0f0f0;\n  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.02);\n  transition: all 0.3s;\n  z-index: 10;\n}\n\n.cmslayout-sider-light .ant-layout-sider-trigger:hover {\n  background: #fafafa !important;\n  color: #35c759 !important;\n}\n\n/* ========== Packages Management ========== */\n.package-list-wrap {\n  padding: 20px;\n  background: #fff;\n  border-radius: 20px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);\n}\n\n.package-list-wrap-empty {\n  min-height: calc(100vh - 250px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.package-loading-state {\n  min-height: 280px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.package-filter-group {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 0;\n}\n\n.package-filter-group .ant-radio-button-wrapper {\n  border-radius: 10px;\n  margin-left: 6px;\n  border-inline-start-width: 1px;\n}\n\n.package-filter-group .ant-radio-button-wrapper:first-child {\n  margin-left: 0;\n}\n\n.package-filter-group .ant-radio-button-wrapper-checked {\n  border-color: #35b558 !important;\n  color: #35b558 !important;\n}\n\n.packages-card-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(420px, 1fr));\n  gap: 16px;\n  width: 100%;\n  align-items: start;\n  justify-content: stretch;\n}\n\n.package-card {\n  display: flex;\n  gap: 16px;\n  padding: 18px;\n  background: #fff;\n  border: 1px solid #f0f0f0;\n  border-radius: 14px;\n  box-shadow: 0 8px 22px rgba(25, 38, 31, 0.06);\n  min-width: 0;\n  width: 100%;\n  align-items: stretch;\n}\n\n.package-card-image {\n  width: 118px;\n  height: 118px;\n  min-width: 118px;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #f7faf8;\n  border: 1px solid #eef3ef;\n}\n\n.package-card-image-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.package-card-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background:\n    linear-gradient(135deg, rgba(53, 181, 88, 0.08), rgba(53, 181, 88, 0.02)),\n    #f7faf8;\n  color: #35b558;\n}\n\n.package-card-placeholder .anticon {\n  font-size: 36px;\n}\n\n.package-card-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.package-card-title-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 4px;\n}\n\n.package-card-name {\n  color: #1a1a1a;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.package-card-price {\n  color: #35b558;\n  font-size: 16px;\n  font-weight: 700;\n  text-transform: capitalize;\n}\n\n.package-card-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  color: #666;\n  font-size: 12px;\n  margin-top: 6px;\n}\n\n.package-card-meta span {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.package-card-description {\n  color: #666;\n  display: -webkit-box;\n  font-size: 13px;\n  line-height: 1.45;\n  margin-top: 8px;\n  overflow: hidden;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n}\n\n.package-card-actions {\n  justify-content: flex-start;\n}\n\n.package-form-modal .ant-modal-body {\n  max-height: 76vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.package-input-number,\n.package-input-number.ant-input-number {\n  width: 100%;\n  border-radius: 12px;\n}\n\n.package-status-switch.ant-switch-checked {\n  background: #35b558;\n}\n\n.package-upload-box {\n  width: 180px;\n  height: 140px;\n  border-radius: 12px;\n  overflow: hidden;\n  border: 1px solid #f0f0f0;\n  background: #f6ffed;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.package-upload-box .ant-upload,\n.package-upload-box .ant-upload-select {\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n.package-upload-placeholder {\n  width: 100%;\n  height: 100%;\n  min-height: 138px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  cursor: pointer;\n  text-align: center;\n}\n\n.package-upload-box .add-mart-upload-preview {\n  width: 100%;\n  height: 100%;\n}\n\n.package-product-option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n}\n\n.package-product-option small {\n  color: #8c8c8c;\n  font-size: 11px;\n  white-space: nowrap;\n}\n\n.package-select-state {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: #8c8c8c;\n}\n\n.package-builder-stack,\n.package-items-builder {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.package-benefit-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 40px;\n  gap: 8px;\n  align-items: center;\n}\n\n.package-item-row {\n  display: grid;\n  grid-template-columns:\n    minmax(150px, 1fr) minmax(180px, 1.35fr) minmax(72px, 0.45fr) minmax(190px, 1.2fr) minmax(112px, auto) 40px;\n  gap: 8px;\n  align-items: center;\n  padding: 10px;\n  border: 1px solid #f0f0f0;\n  border-radius: 12px;\n  background: #fafafa;\n  min-width: 0;\n}\n\n.package-item-row .ant-select,\n.package-item-row .ant-input-number {\n  min-width: 0;\n}\n\n.package-item-quantity,\n.package-item-quantity.ant-input-number,\n.package-item-unit {\n  width: 100%;\n}\n\n.package-add-line-btn {\n  height: 40px;\n  border-radius: 10px;\n  color: #35b558;\n  border-color: #b7eb8f;\n}\n\n.package-add-line-btn:hover {\n  color: #2da24e !important;\n  border-color: #35b558 !important;\n}\n\n.package-modal-footer .ant-form-item-control-input-content {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  background: #fff;\n}\n\n.package-modal-footer .markets-add-btn {\n  width: auto;\n  min-width: 150px;\n}\n\n.package-detail-hero {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  margin-bottom: 18px;\n}\n\n.package-detail-image {\n  width: 132px;\n  height: 132px;\n  border-radius: 14px;\n  background: #f7faf8;\n  border: 1px solid #eef3ef;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.package-detail-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.package-detail h2 {\n  color: #1a1a1a;\n  font-size: 24px;\n  font-weight: 700;\n  margin-bottom: 6px;\n}\n\n.package-detail-price {\n  color: #35b558;\n  font-size: 17px;\n  font-weight: 700;\n  margin-bottom: 8px;\n  text-transform: capitalize;\n}\n\n.package-detail-section {\n  margin-top: 18px;\n}\n\n.package-detail-section h3 {\n  color: #1a1a1a;\n  font-size: 16px;\n  font-weight: 700;\n  margin-bottom: 10px;\n}\n\n.package-detail-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.package-detail-list li {\n  color: #4d4d4d;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.package-detail-list .anticon {\n  color: #35b558;\n  flex-shrink: 0;\n}\n\n.package-detail-category {\n  padding: 12px;\n  border: 1px solid #f0f0f0;\n  border-radius: 12px;\n  background: #fafafa;\n  margin-bottom: 10px;\n}\n\n.package-detail-category-title {\n  color: #1a1a1a;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n\n@media (max-width: 991px) {\n  .packages-card-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .package-filter-group {\n    justify-content: flex-start;\n  }\n\n  .package-item-row {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  }\n}\n\n@media (max-width: 576px) {\n\n  .package-card,\n  .package-detail-hero {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .package-card-image {\n    width: 100%;\n    height: 160px;\n  }\n\n  .package-item-row {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .package-modal-footer .ant-form-item-control-input-content {\n    flex-direction: column-reverse;\n  }\n\n  .package-modal-footer .markets-add-btn {\n    width: 100%;\n  }\n}\n\n/* ========== Master Products ========== */\n.master-product-info-banner {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 12px 14px;\n  margin-bottom: 16px;\n  border: 1px solid #d9f7be;\n  border-radius: 12px;\n  background: #f6ffed;\n  color: #3f5f45;\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n.master-product-info-banner .anticon {\n  color: #35b558;\n  margin-top: 3px;\n}\n\n.master-product-category-filter {\n  width: 100%;\n}\n\n.master-product-header-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.master-product-csv-input {\n  display: none;\n}\n\n.master-product-list-wrap {\n  padding: 0;\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);\n  overflow: hidden;\n}\n\n.master-product-list-wrap-empty {\n  min-height: calc(100vh - 270px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.master-product-code {\n  display: inline-flex;\n  align-items: center;\n  max-width: 100%;\n  padding: 3px 8px;\n  margin-bottom: 5px;\n  border-radius: 999px;\n  background: #f6ffed;\n  color: #2e7d32;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.2px;\n  word-break: break-word;\n}\n\n.master-product-code-input.ant-input {\n  color: #2e7d32;\n  font-weight: 700;\n  background: #f6ffed;\n  border-color: #d9f7be;\n}\n\n.master-products-table .ant-table {\n  border-radius: 16px;\n}\n\n.master-products-table .ant-table-thead>tr>th {\n  background: #f8fbf8;\n  color: #374151;\n  font-size: 12px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.master-products-table .ant-table-tbody>tr>td {\n  padding-top: 11px;\n  padding-bottom: 11px;\n  vertical-align: middle;\n}\n\n.master-product-table-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.master-product-csv-summary {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.master-product-csv-summary .ant-statistic {\n  padding: 12px 14px;\n  border: 1px solid #eef3ef;\n  border-radius: 12px;\n  background: #f8fbf8;\n}\n\n.master-product-csv-errors {\n  display: flex;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n\n.master-product-csv-invalid-row>td {\n  background: #fff7f7 !important;\n}\n\n@media (max-width: 991px) {\n  .master-product-header-actions {\n    justify-content: flex-start;\n    width: 100%;\n  }\n\n  .master-product-status-filter {\n    justify-content: flex-start;\n  }\n}\n\n@media (max-width: 576px) {\n  .master-product-csv-summary {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
